<template>
  <div class="xin">
    <!-- tab 切换  -->
    <div class="switch">
      <el-tabs @tab-click="handleClick_tab" v-model="activeName">
        <!-- 邮件传送 -->
        <el-tab-pane>
          <span slot="label"> {{ $t("logs.base1") }} </span>
          <div class="base1_ip">
            <div class="base1_left">
              <p>{{ $t("logs.base1_a1") }}</p>
              <div class="table table01">
                <el-table
                  ref="multipleTable"
                  tooltip-effect="dark"
                  style="width: 100%"
                  :data="fileList"
                  :row-class-name="tableRowClassName"
                  v-loading="loading"
                >
                  <el-table-column
                    prop="RECSEQ"
                    :label="$t('logs.xuhao')"
                    width="100"
                  ></el-table-column>
                  <el-table-column
                    prop="MYNETWORK"
                    :label="$t('logs.base2_a2')"
                  ></el-table-column>

                  <el-table-column
                    prop="address"
                    :label="$t('logs.audit6')"
                    width="120"
                  >
                    <template slot-scope="scope">
                      <!-- 删除-->
                      <el-button
                        @click="handleClick1(scope.$index, scope.row)"
                        type="text"
                        size="small"
                        :disabled="$root.jurisdiction.only_query == 0"
                      >
                        {{ $t("table1.delete") }}</el-button
                      >
                    </template>
                  </el-table-column>
                </el-table>
              </div>
            </div>
            <div class="base1_right">
              <div class="base1_right_top">
                <p>{{ $t("logs.base1_a4") }}</p>
                <ul class="td_last_button">
                  <li>{{ $t("logs.base1_a2") }}</li>
                  <el-input v-model="mtaip" placeholder></el-input>
                  <el-button
                    type="primary"
                    @click="tanSend_table()"
                    :disabled="$root.jurisdiction.only_query == 0"
                    >{{ $t("logs.save_a") }}</el-button
                  >
                </ul>
              </div>
              <div class="base1_right_c  td_last_button">
                <p class="base1_right_ctext">
                  <span style="margin-left:14px"></span>
                  {{ $t("logs.base1_a5") }}
                </p>
                <div class="base1_right_center">
                  <ol>
                    <li>{{ $t("logs.base1_a7") }}:</li>
                    <li>
                      <el-input v-model="mydomain" placeholder></el-input>
                    </li>
                  </ol>
                  <ol style="margin-bottom:14px">
                    <li></li>
                    <li>
                      <el-alert
                        :title="$t('logs.base1_a12')"
                        type="warning"
                        show-icon
                        :closable="false"
                      ></el-alert>
                    </li>
                  </ol>
                  <ol>
                    <li>{{ $t("logs.base1_a9") }}:</li>
                    <li>
                      <el-input v-model="myhostname" placeholder></el-input>
                    </li>
                  </ol>
                  <ol style="margin-bottom:14px">
                    <li></li>
                    <li>
                      <el-alert
                        :title="$t('logs.base1_a13')"
                        type="warning"
                        show-icon
                        :closable="false"
                      ></el-alert>
                    </li>
                  </ol>
                  <ol>
                    <li></li>
                    <li class="base1_right_center_button">
                      <el-button
                        type="primary"
                        @click="tanSend_domain()"
                        :disabled="$root.jurisdiction.only_query == 0"
                        >{{ $t("logs.save_a") }}</el-button
                      >
                    </li>
                  </ol>
                </div>
              </div>
            </div>
          </div>
        </el-tab-pane>
        <!-- 默认域名 -->
        <el-tab-pane>
          <span slot="label"> {{ $t("logs.base2") }} </span>
          <div class="lie">
            <table>
              <tbody>
                <tr>
                  <!-- 输入域名 -->

                  <td>{{ $t("logs.base2_a2") }}:</td>
                  <td>
                    <el-input v-model="filterdomain" placeholder></el-input>
                  </td>
                </tr>

                <tr>
                  <!-- 输入域名 -->

                  <td>{{ $t("logs.base2_a2") }}:</td>
                  <td>
                    <el-input v-model="authdomain" placeholder></el-input>
                  </td>
                </tr>

                <tr>
                  <td></td>
                  <td
                    style="display:flex;flex-direction:row"
                    class="td_last_button"
                  >
                    <el-button
                      type="primary"
                      @click="tanSend_table1()"
                      :disabled="$root.jurisdiction.only_query == 0"
                      >{{ $t("logs.save_a") }}</el-button
                    >
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </el-tab-pane>

        <!-- 中继域名 -->
        <el-tab-pane label>
          <span slot="label"> {{ $t("logs.base3") }} </span>
          <div class="main">
            <el-button
              @click="tan()"
              :disabled="$root.jurisdiction.only_query == 0"
              >{{ $t("logs.base3_a1") }}</el-button
            >
            <el-alert
              :title="$t('logs.base3_a2')"
              type="warning"
              show-icon
              :closable="false"
            ></el-alert>
          </div>
          <div class="switch1">
            <div class="table table03">
              <el-table
                ref="multipleTable"
                tooltip-effect="dark"
                style="width: 100%"
                :data="fileList3"
                :row-class-name="tableRowClassName"
              >
                <el-table-column
                  prop="RECSEQ"
                  :label="$t('logs.xuhao')"
                  width="140"
                ></el-table-column>
                <el-table-column
                  prop="RELAY_DOMAIN"
                  :label="$t('logs.base2_a2')"
                ></el-table-column>

                <el-table-column
                  prop="address"
                  :label="$t('logs.audit6')"
                  width="120"
                >
                  <template slot-scope="scope">
                    <!-- 删除-->
                    <el-button
                      @click="handleClick3(scope.$index, scope.row)"
                      type="text"
                      size="small"
                      :disabled="$root.jurisdiction.only_query == 0"
                    >
                      {{ $t("table1.delete") }}</el-button
                    >
                  </template>
                </el-table-column>
              </el-table>
            </div>
            <div class="pop-up" v-show="tanchu"  v-drag="{ handle: '.pop_up_text_relay_domain' }">
              <!--   添加中继域名 -->
              <div class="pop_up_text pop_up_text_relay_domain"> <span class="span_pad"></span>{{ $t("logs.base3_a3") }}</div>
              <p></p>
              <div class="find">
                <div class="find1">
                  <div class="find-text" style="padding-right:12px">
                    {{ $t("logs.base2_a2") }}:
                  </div>
                  <div class="block block1">
                    <el-input v-model="relay_domain" placeholder></el-input>
                  </div>
                </div>
              </div>

              <el-row>
                <el-button type="primary" @click="tanSend_table3()"  :disabled="$root.jurisdiction.only_query == 0" >{{
                  $t("logs.save_a")
                }}</el-button>
                <el-button type="danger" @click="tanSend()">{{
                  $t("logs.save_b")
                }}</el-button>
              </el-row>
            </div>
            <div class="gray" v-show="tanchu"></div>
          </div>
        </el-tab-pane>
        <!-- 本地域名 -->
        <el-tab-pane label>
          <span slot="label"> {{ $t("logs.base4") }} </span>
          <div class="main">
            <el-button
              @click="tan()"
              :disabled="$root.jurisdiction.only_query == 0"
              >{{ $t("logs.base4_a1") }}</el-button
            >
            <el-alert
              :title="$t('logs.base4_a2')"
              type="warning"
              show-icon
              :closable="false"
            ></el-alert>
          </div>
          <div class="switch1">
            <div class="table table03 table_fenye">
              <el-table
                ref="multipleTable4"
                tooltip-effect="dark"
                style="width: 100%"
                :data="fileList4"
                :row-class-name="tableRowClassName"
              >
                <el-table-column
                  prop="RECSEQ"
                  :label="$t('logs.xuhao')"
                  width="140"
                ></el-table-column>
                <el-table-column
                  prop="LOCAL_DOMAIN"
                  :label="$t('logs.base2_a2')"
                ></el-table-column>

                <el-table-column
                  prop="address"
                  :label="$t('logs.audit6')"
                  width="120"
                >
                  <template slot-scope="scope">
                    <!-- 删除-->
                    <el-button
                      @click="handleClick4(scope.$index, scope.row)"
                      type="text"
                      size="small"
                      :disabled="$root.jurisdiction.only_query == 0"
                    >
                      {{ $t("table1.delete") }}</el-button
                    >
                  </template>
                </el-table-column>
              </el-table>
            </div>
            <!--  分页 -->
            <div class="fenye">
              <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page.sync="page"
                :page-sizes="[10, 20, 50, 100]"
                :page-size="size"
                layout="total, sizes, prev, pager, next, jumper"
                :total="totalnums"
              ></el-pagination>
            </div>
            <div class="pop-up" v-show="tanchu" v-drag="{ handle: '.pop_up_text_local_domain' }">
              <!--   添加本地域名 -->
              <div class="pop_up_text pop_up_text_local_domain"><span class="span_pad"></span>{{ $t("logs.base4_a3") }}</div>
              <p></p>
              <div class="find">
                <div class="find1">
                  <div class="find-text" style="padding-right:12px">
                    {{ $t("logs.base2_a2") }}:
                  </div>
                  <div class="block block1">
                    <el-input v-model="local_domain" placeholder></el-input>
                  </div>
                </div>
              </div>

              <el-row>
                <el-button type="primary" @click="tanSend_table4()" :disabled="$root.jurisdiction.only_query == 0">{{
                  $t("logs.save_a")
                }}</el-button>
                <el-button type="danger" @click="tanSend()">{{
                  $t("logs.save_b")
                }}</el-button>
              </el-row>
            </div>
            <div class="gray" v-show="tanchu"></div>
          </div>
        </el-tab-pane>
        <!-- 路由设置 -->
        <el-tab-pane label>
          <span slot="label"> {{ $t("logs.base5") }} </span>
          <div class="main">
            <el-button
              @click="tan()"
              :disabled="$root.jurisdiction.only_query == 0"
              >{{ $t("logs.base5_a1") }}</el-button
            >
            <el-alert
              :title="$t('logs.base5_a2')"
              type="warning"
              show-icon
              :closable="false"
            ></el-alert>
          </div>
          <div class="switch1">
            <div class="table table05">
              <el-table
                ref="multipleTable"
                tooltip-effect="dark"
                style="width: 100%"
                :data="fileList5"
                :row-class-name="tableRowClassName"
              >
                <el-table-column
                  prop="RECSEQ"
                  :label="$t('logs.xuhao')"
                  width="100px"
                ></el-table-column>
                <el-table-column
                  prop="ROUTE_ADDRESS"
                  :label="$t('logs.base5_a3')"
                  width="140px"
                ></el-table-column>
                <el-table-column
                  prop="ROUTE_IP"
                  :label="$t('logs.base5_a4')"
                ></el-table-column>
                <el-table-column
                  prop="ROUTE_PORT"
                  :label="$t('logs.base5_a5')"
                  width="140px"
                ></el-table-column>
<el-table-column
                  prop="SHOW_ROUTE_TYPE"
                  :label="$t('logs.base5_a8')"
                  width="120px"
                ></el-table-column>
                <el-table-column
                  prop="address"
                  :label="$t('logs.audit6')"
                  width="120px"
                >
                  <template slot-scope="scope">
                    <!-- 删除-->
                    <el-button
                      @click="handleClick5(scope.$index, scope.row)"
                      type="text"
                      size="small"
                      :disabled="$root.jurisdiction.only_query == 0"
                    >
                      {{ $t("table1.delete") }}</el-button
                    >
                    <!-- 编辑 -->

                    <el-button
                      type="text"
                      size="small"
                      :disabled="$root.jurisdiction.only_query == 0"
                      @click="save05(scope.$index, scope.row)"
                      >{{ $t("table1.ditt") }}</el-button
                    >
                  </template>
                </el-table-column>
              </el-table>
            </div>
            <div
              class="pop-up"
              v-show="tanchu"
              v-drag="{ handle: '.pop_up_text_ROUTE_ADDRESS' }"
            >
              <!--  路由设置-->
              <div class="pop_up_text pop_up_text_ROUTE_ADDRESS">
               <span class="span_pad"></span>{{ $t("logs.base5_a6") }}
              </div>
              <p></p>
              <div class="find">
                <div class="find1">
                  <div class="find-text" style="padding-right:12px">
                    {{ $t("logs.base5_a3") }}:
                  </div>
                  <div class="block block1">
                    <el-input v-model="route_address" placeholder></el-input>
                  </div>
                </div>
                <div class="find1">
                  <div class="find-text" style="padding-right:12px">
                    {{ $t("logs.base5_a4") }}:
                  </div>
                  <div class="block block1">
                    <el-input v-model="route_ip" placeholder></el-input>
                    <el-alert
                      :title="$t('logs.base5_a7')"
                      type="warning"
                      show-icon
                      :closable="false"
                    ></el-alert>
                  </div>
                </div>

                <div class="find1">
                  <div class="find-text" style="padding-right:12px">
                    {{ $t("logs.base5_a5") }}:
                  </div>
                  <div class="block block1">
                    <el-input v-model="route_port" placeholder></el-input>
                  </div>
                </div>
                <div class="find1">
                  <div class="find-text" style="padding-right:12px">
                    {{ $t("logs.base5_a8") }}:
                  </div>
                  <div class="block block1">
                    <el-radio-group v-model="route_type">
                      
                      <el-radio :label="1">{{
                        $t("logs.group7_a16")
                      }}</el-radio>
                      <el-radio :label="2">{{
                        $t("logs.group7_a15")
                      }}</el-radio>
                    </el-radio-group>
                  </div>
                </div>
              </div>

              <el-row>
                <el-button type="primary" @click="tanSend_table5()" :disabled="$root.jurisdiction.only_query == 0">{{
                  $t("logs.save_a")
                }}</el-button>
                <el-button type="danger" @click="tanSend()">{{
                  $t("logs.save_b")
                }}</el-button>
              </el-row>
            </div>
            <div class="gray" v-show="tanchu"></div>
            <div class="pop-up" v-show="tanchu2" v-drag="{ handle: '.pop_up_text_ROUTE_ADDRESS_edit' }"
            >
              <!--  路由设置-->
              <div class="pop_up_text pop_up_text_ROUTE_ADDRESS_edit">
               <span class="span_pad"></span>{{ $t("logs.base5_a9") }}
              </div>
              <p></p>
              <div class="find">
                <div class="find1">
                  <div class="find-text" style="padding-right:12px">
                    {{ $t("logs.base5_a3") }}:
                  </div>
                  <div class="block block1">
                    <p style="text-align:left;color:#0e2c5e">
                      {{ this.route_address }}
                    </p>
                  </div>
                </div>
                <div class="find1">
                  <div class="find-text" style="padding-right:12px">
                    {{ $t("logs.base5_a4") }}:
                  </div>
                  <div class="block block1">
                    <el-input v-model="route_ip" placeholder></el-input>
                    <el-alert
                      :title="$t('logs.base5_a7')"
                      type="warning"
                      show-icon
                      :closable="false"
                    ></el-alert>
                  </div>
                </div>
 
                <div class="find1">
                  <div class="find-text" style="padding-right:12px">
                    {{ $t("logs.base5_a5") }}:
                  </div>
                  <div class="block block1">
                    <el-input v-model="route_port_sender" placeholder></el-input>
                  </div>
                </div>
                 <div class="find1">
                <div class="find-text" style="padding-right:12px">
                  {{ $t("logs.base5_a8") }}:
                </div>
                <div class="block block1">
                  <el-radio-group v-model="route_type">
                    <el-radio :label="1">{{ $t("logs.group7_a16") }}</el-radio>
                    <el-radio :label="2">{{ $t("logs.group7_a15") }}</el-radio>
                  </el-radio-group>
                </div>
              </div>
              </div>
            
              <el-row>
                <el-button type="primary" @click="tanSend_table5_save()" :disabled="$root.jurisdiction.only_query == 0">{{
                  $t("logs.save_a")
                }}</el-button>
                <el-button type="danger" @click="tanSend_off()">{{
                  $t("logs.save_b")
                }}</el-button>
              </el-row>
            </div>
            <div class="gray" v-show="tanchu2"></div>
          </div>
        </el-tab-pane>
         <!--  发件人路由 -->
        <el-tab-pane label>
          <span slot="label"> {{ $t("logs.base_address") }} </span>
          <div class="main">
            <el-button
              @click="tan()"
              :disabled="$root.jurisdiction.only_query == 0"
              >{{ $t("logs.base5_a1") }}</el-button
            >
            
          </div>
          <div class="switch1">
            <div class="table table05">
              <el-table
                ref="multipleTable"
                tooltip-effect="dark"
                style="width: 100%"
                :data="fileList5_sender"
                :row-class-name="tableRowClassName"
              >
                <el-table-column
                  prop="RECSEQ"
                  :label="$t('logs.xuhao')"
                  width="100px"
                ></el-table-column>
                <el-table-column
                  prop="SENDER"
                  :label="$t('logs.base5_a3_sender')"
                  width="140px"
                ></el-table-column>
                <el-table-column
                  prop="RELAY_IP"
                  :label="$t('logs.base5_a4')"
                ></el-table-column>
                <el-table-column
                  prop="RELAY_PORT"
                  :label="$t('logs.base5_a5')"
                  width="140px"
                ></el-table-column>
<!-- <el-table-column
                  prop="SHOW_ROUTE_TYPE"
                  :label="$t('logs.base5_a8')"
                  width="120px"
                ></el-table-column> -->
                <el-table-column
                  prop="address"
                  :label="$t('logs.audit6')"
                  width="120px"
                >
                  <template slot-scope="scope">
                    <!-- 删除-->
                    <el-button
                      @click="handleClick5_sender(scope.$index, scope.row)"
                      type="text"
                      size="small"
                      :disabled="$root.jurisdiction.only_query == 0"
                    >
                      {{ $t("table1.delete") }}</el-button
                    >
                    <!-- 编辑 -->

                    <el-button
                      type="text"
                      size="small"
                      :disabled="$root.jurisdiction.only_query == 0"
                      @click="save05_sender(scope.$index, scope.row)"
                      >{{ $t("table1.ditt") }}</el-button
                    >
                  </template>
                </el-table-column>
              </el-table>
            </div>
            <div
              class="pop-up"
              v-show="tanchu"
              v-drag="{ handle: '.pop_up_text_import_iup' }"
            >
            
              <div class="pop_up_text pop_up_text_import_iup">
               <span class="span_pad"></span>{{ $t("logs.base5_a6") }}
              </div>
              <p></p>
              <div class="find">
                <div class="find1">
                  <div class="find-text" style="padding-right:12px">
                    {{ $t("logs.base5_a3_sender") }}:
                  </div>
                  <div class="block block1">
                    <el-input v-model="route_address" placeholder></el-input>
                  </div>
                </div>
                <div class="find1">
                  <div class="find-text" style="padding-right:12px">
                    {{ $t("logs.base5_a4") }}:
                  </div>
                  <div class="block block1">
                    <el-input v-model="route_ip" placeholder></el-input>
                    <el-alert
                      :title="$t('logs.base5_a7')"
                      type="warning"
                      show-icon
                      :closable="false"
                    ></el-alert>
                  </div>
                </div>

                <div class="find1">
                  <div class="find-text" style="padding-right:12px">
                    {{ $t("logs.base5_a5") }}:
                  </div>
                  <div class="block block1">
                    <el-input v-model="route_port" placeholder></el-input>
                  </div>
                </div>
                <!-- <div class="find1">
                  <div class="find-text" style="padding-right:12px">
                    {{ $t("logs.base5_a8") }}:
                  </div>
                  <div class="block block1">
                    <el-radio-group v-model="route_type">
                      
                      <el-radio :label="1">{{
                        $t("logs.group7_a16")
                      }}</el-radio>
                      <el-radio :label="2">{{
                        $t("logs.group7_a15")
                      }}</el-radio>
                    </el-radio-group>
                  </div>
                </div> -->
              </div>

              <el-row>
                <el-button type="primary" @click="tanSend_table5_sender()" :disabled="$root.jurisdiction.only_query == 0">{{
                  $t("logs.save_a")
                }}</el-button>
                <el-button type="danger" @click="tanSend()">{{
                  $t("logs.save_b")
                }}</el-button>
              </el-row>
            </div>
            <div class="gray" v-show="tanchu"></div>
            <div class="pop-up" v-show="tanchu2" v-drag="{ handle: '.pop_up_text_import_br' }"
            >
              <!--  路由设置-->
              <div class="pop_up_text pop_up_text_import_br">
               <span class="span_pad"></span>{{ $t("logs.base5_a9") }}
              </div>
              <p></p>
              <div class="find">
                <div class="find1">
                  <div class="find-text" style="padding-right:12px">
                    {{ $t("logs.base5_a3_sender") }}:
                  </div>
                  <div class="block block1">
                    <p style="text-align:left;color:#0e2c5e">
                      {{ this.route_address }}
                    </p>
                  </div>
                </div>
                <div class="find1">
                  <div class="find-text" style="padding-right:12px">
                    {{ $t("logs.base5_a4") }}:
                  </div>
                  <div class="block block1">
                    <el-input v-model="route_ip" placeholder></el-input>
                    <el-alert
                      :title="$t('logs.base5_a7')"
                      type="warning"
                      show-icon
                      :closable="false"
                    ></el-alert>
                  </div>
                </div>
 
                <div class="find1">
                  <div class="find-text" style="padding-right:12px">
                    {{ $t("logs.base5_a5") }}:
                  </div>
                  <div class="block block1">
                    <el-input v-model="route_port" placeholder></el-input>
                  </div>
                </div>
                 <!-- <div class="find1">
                <div class="find-text" style="padding-right:12px">
                  {{ $t("logs.base5_a8") }}:
                </div>
                <div class="block block1">
                  <el-radio-group v-model="route_type">
                    <el-radio :label="1">{{ $t("logs.group7_a16") }}</el-radio>
                    <el-radio :label="2">{{ $t("logs.group7_a15") }}</el-radio>
                  </el-radio-group>
                </div>
               </div> -->
              </div>
            
              <el-row>
                <el-button type="primary" @click="tanSend_table5_save_sender()" :disabled="$root.jurisdiction.only_query == 0">{{
                  $t("logs.save_a")
                }}</el-button>
                <el-button type="danger" @click="tanSend_off()">{{
                  $t("logs.save_b")
                }}</el-button>
              </el-row>
            </div>
            <div class="gray" v-show="tanchu2"></div>
          </div>
        </el-tab-pane>
        <!-- TLS设置 -->
        <el-tab-pane label>
          <span slot="label"> {{ $t("logs.base6") }} </span>
          <div class="main">
            <el-button
              @click="tan()"
              :disabled="$root.jurisdiction.only_query == 0"
              >{{ $t("logs.base6_a1") }}</el-button
            >
            <el-alert
              :title="$t('logs.base6_a2')"
              type="warning"
              show-icon
              :closable="false"
            ></el-alert>
          </div>
          <div class="switch1">
            <div class="table table06">
              <el-table
                ref="multipleTable"
                tooltip-effect="dark"
                style="width: 100%"
                :data="fileList6"
                :row-class-name="tableRowClassName"
              >
                <el-table-column
                  prop="RECSEQ"
                  :label="$t('logs.xuhao')"
                  width="100"
                ></el-table-column>

                <el-table-column
                  prop="TLS_ADDRESS"
                  :label="$t('logs.base6_a3')"
                ></el-table-column>

                <el-table-column
                  prop="TLS_TYPE"
                  :label="$t('logs.base6_a4')"
                ></el-table-column>
                <el-table-column
                  prop="address"
                  :label="$t('logs.audit6')"
                  width="100"
                >
                  <template slot-scope="scope">
                    <!-- 删除-->
                    <el-button
                      @click="handleClick6(scope.$index, scope.row)"
                      type="text"
                      size="small"
                      :disabled="$root.jurisdiction.only_query == 0"
                    >
                      {{ $t("table1.delete") }}</el-button
                    >
                  </template>
                </el-table-column>
              </el-table>
            </div>
            <div class="pop-up" v-show="tanchu"  v-drag="{ handle: '.pop_up_text_tls_address' }">
              <!--  tls设置-->
              <div class="pop_up_text pop_up_text_tls_address"><span class="span_pad"></span>{{ $t("logs.base6_a5") }}</div>
              <p></p>
              <div class="find">
                <div class="find1">
                  <div class="find-text" style="padding-right:12px">
                    {{ $t("logs.base6_a3") }}:
                  </div>
                  <div class="block block1">
                    <el-input v-model="tls_address" placeholder></el-input>
                  </div>
                </div>
                <div class="find1">
                  <div class="find-text" style="padding-right:12px">
                    {{ $t("logs.base6_a4") }}:
                  </div>
                  <div class="block block1">
                    <el-select v-model="tls_type" placeholder="请选择">
                      <el-option
                        v-for="item in tls_typee"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      >
                      </el-option>
                    </el-select>
                  </div>
                </div>
              </div>

              <el-row>
                <el-button type="primary" @click="tanSend_table6()" :disabled="$root.jurisdiction.only_query == 0">{{
                  $t("logs.save_a")
                }}</el-button>
                <el-button type="danger" @click="tanSend()">{{
                  $t("logs.save_b")
                }}</el-button>
              </el-row>
            </div>
            <div class="gray" v-show="tanchu"></div>
          </div>
        </el-tab-pane>
        <!-- 时间设置 -->
        <el-tab-pane name="load_sys_time" v-loading="loading">
          <span slot="label"> {{ $t("logs.base7") }} </span>
          <div class="lie">
            <table>
              <tbody>
                <tr>
                  <!-- 系统时间 -->

                  <td>{{ $t("logs.base7_a1") }}:</td>
                  <td>
                    <p class="system_time">
                      {{ dataform(systime_time) }}
                    </p>
                    <!-- 系统时间 

                                    <el-input :value="`${dateFormat(date)}`"> </el-input>-->
                  </td>
                </tr>
                <tr>
                  <!-- 本地时间 -->

                  <td>{{ $t("logs.base7_a2") }}:</td>
                  <td style="display:flex;flex-direction:row">
                    <el-date-picker
                      v-model="date_time"
                      type="datetime"
                      placeholder="选择日期时间"
                      format="yyyy-MM-dd HH:mm:ss"
                      value-format="yyyy-MM-dd HH:mm:ss"
                      class="base7_a2_time"
                    >
                    </el-date-picker>

                    <el-button
                      :disabled="$root.jurisdiction.only_query == 0"
                      @click="tanSend_table_time()"
                      class="system_time_lacal"
                      >{{ $t("logs.base7_a4") }}</el-button
                    >
                  </td>
                </tr>
                <tr>
                  <!-- NTP 服务器-->

                  <td>{{ $t("logs.base7_a3") }}:</td>
                  <td style="display:flex;flex-direction:row">
                    <el-input v-model="ntp_server" placeholder></el-input>
                    <el-button
                      :disabled="$root.jurisdiction.only_query == 0"
                      type="primary"
                      @click="tanSend_table_ntp()"
                      class="system_time_lacal"
                      >{{ $t("logs.base7_a5") }}</el-button
                    >
                  </td>
                </tr>

                <tr>
                  <td></td>
                  <td style="display:flex;flex-direction:row"></td>
                </tr>
              </tbody>
            </table>
          </div>
        </el-tab-pane>

        <!-- 后台访问控制 -->
        <el-tab-pane>
          <span slot="label"> {{ $t("logs.base8") }} </span>
          <div class="lie">
            <table>
              <tbody>
                <tr>
                  <!-- 启用 -->

                  <td>{{ $t("logs.base8_a1") }}:</td>
                  <td style="display:flex; flex-direction:row">
                    <el-checkbox-group v-model="limit_access">
                      <el-checkbox label></el-checkbox>
                    </el-checkbox-group>
                    <el-alert
                      :title="$t('logs.base8_a2')"
                      type="warning"
                      show-icon
                      :closable="false"
                    ></el-alert>
                  </td>
                </tr>
                <tr>
                  <!-- 设置可访问IP范围 -->

                  <td>{{ $t("logs.base8_a3") }}:</td>
                  <td style="display:flex; flex-direction:row">
                    <el-input v-model="ip_range" placeholder></el-input>
                    <el-alert
                      :title="$t('logs.base8_a4')"
                      type="warning"
                      show-icon
                      :closable="false"
                    ></el-alert>
                  </td>
                </tr>
                <tr>
                  <!-- 启用 -->

                  <td>{{ $t("logs.base8_a1") }}:</td>
                  <td style="display:flex; flex-direction:row">
                    <el-checkbox-group v-model="super_access">
                      <el-checkbox label></el-checkbox>
                    </el-checkbox-group>
                    <el-alert
                      :title="$t('logs.base8_a5')"
                      type="warning"
                      show-icon
                      :closable="false"
                    ></el-alert>
                  </td>
                </tr>

                <tr>
                  <!-- 设置特权IP范围 -->

                  <td>{{ $t("logs.base8_a6") }}:</td>
                  <td style="display:flex; flex-direction:row">
                    <el-input v-model="super_ip" placeholder></el-input>
                    <el-alert
                      :title="$t('logs.base8_a7')"
                      type="warning"
                      show-icon
                      :closable="false"
                    ></el-alert>
                  </td>
                </tr>
                <tr>
                  <!-- 最大登录错误次数 -->

                  <td>{{ $t("logs.base8_a8") }}:</td>
                  <td style="display:flex; flex-direction:row">
                    <el-input v-model="max_login_err" placeholder></el-input>
                    <el-alert
                      :title="$t('logs.base8_a9')"
                      type="warning"
                      show-icon
                      :closable="false"
                    ></el-alert>
                  </td>
                </tr>
                <tr>
                  <!-- 登录错误限制时间 -->

                  <td>{{ $t("logs.base8_a10") }}:</td>
                  <td style="display:flex; flex-direction:row">
                    <el-input v-model="max_login_time" placeholder></el-input>
                    <el-alert
                      :title="$t('logs.base8_a11')"
                      type="warning"
                      show-icon
                      :closable="false"
                    >
                    </el-alert>
                  </td>
                </tr>

                <tr>
                  <td></td>
                  <td style="display:flex;flex-direction:row">
                    <el-button
                      type="primary"
                      @click="tanSend_table8()"
                      :disabled="$root.jurisdiction.only_query == 0"
                      >{{ $t("logs.save_a") }}</el-button
                    >
                    <!--  
                                    <el-button type="danger" @click="tanSend()">{{$t('logs.save_b')}}</el-button>-->
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </el-tab-pane>
        <!-- License管理 -->
        <el-tab-pane>
          <span slot="label"> {{ $t("logs.base9") }}</span>
          <div class="lie">
            <table>
              <tbody>
                <tr>
                  <!-- 当前license到期时间 -->

                  <td>{{ $t("logs.base9_a1") }}:</td>
                  <td>
                    <p class="License_style">{{ this.expdate }}</p>
                  </td>
                </tr>
                <tr>
                  <!-- 当前license到期时间 -->

                  <td>{{ $t("logs.base9_a2") }}:</td>
                  <td>
                    <p class="License_style">{{ this.expdate_mac }}</p>
                  </td>
                </tr>
                <tr>
                  <!-- 许可证序列号 -->

                  <td>{{ $t("logs.base9_a3") }}:</td>
                  <td style="width:33%">
                    <el-input
                      type="textarea"
                      :autosize="{ minRows: 4,maxRows: 8 }"
                      placeholder="请输入"
                      v-model="license"
                    >
                    </el-input>
                  </td>
                </tr>

                <tr>
                  <td></td>
                  <td style="display:flex;flex-direction:row">
                    <el-button
                      type="primary"
                      @click="tanSend_table9()"
                      :disabled="$root.jurisdiction.only_query == 0"
                      >{{ $t("logs.base9_a4") }}</el-button
                    >
                    <el-button type="danger" @click="tanSend()">{{
                      $t("logs.save_b")
                    }}</el-button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </el-tab-pane>
        <!-- 证书管理 -->
        <el-tab-pane label>
          <span slot="label"> {{ $t("logs.base10") }} </span>
          <div v-show="selft_build2">
            <div class="main">
              <p>
                <el-button
                  @click="Certificate_Profile2()"
                  :disabled="$root.jurisdiction.only_query == 0"
                  >{{ $t("logs.base10_a18") }}</el-button
                >
                <!-- 配置证书 -->
              </p>
              <el-alert
                :title="this.selft_build_value1"
                type="warning"
                show-icon
                :closable="false"
                class="selft_build1_length"
              ></el-alert>
            </div>
          </div>
          <div v-show="selft_build1">
            <div class="main">
              <p>
                <el-button
                  @click="Certificate_Profile()"
                  :disabled="$root.jurisdiction.only_query == 0"
                  >{{ $t("logs.base10_a18") }}</el-button
                >
                <!-- 配置证书 -->
              </p>
              <el-alert
                :title="this.selft_build_value"
                type="warning"
                show-icon
                :closable="false"
                class="selft_build1_length"
              ></el-alert>
            </div>
          </div>
          <div class="selft_build" v-show="selft_build" v-loading="loading">
            <div class="main">
              <p>
                <el-button
                  @click="tan1()"
                  :disabled="$root.jurisdiction.only_query == 0"
                  >{{ $t("logs.base10_a1") }}</el-button
                >
                <!-- 自建证书 -->
                <el-button
                  @click="tan()"
                  :disabled="$root.jurisdiction.only_query == 0"
                  >{{ $t("logs.base10_a2") }}</el-button
                >
              </p>
              <el-alert
                :title="$t('logs.base10_a3')"
                type="warning"
                show-icon
                :closable="false"
              ></el-alert>
            </div>
            <div class="switch1">
              <div class="table">
                <el-table
                  ref="multipleTable"
                  tooltip-effect="dark"
                  style="width: 100%"
                  :data="fileList10"
                  :row-class-name="tableRowClassName"
                >
                  <el-table-column
                    prop="APACHE_DOMAIN"
                    :label="$t('logs.base10_a4')"
                    width="240"
                  ></el-table-column>
                  <el-table-column
                    prop="ISSUER"
                    :label="$t('logs.base10_a5')"
                  ></el-table-column>
                  <el-table-column
                    prop="APACHE_CR_TIME"
                    :label="$t('logs.base10_a6')"
                    width="200"
                  ></el-table-column>

                  <el-table-column
                    prop="APACHE_EX_TIME"
                    :label="$t('logs.base10_a7')"
                    width="200"
                  ></el-table-column>
                </el-table>
              </div>
              <!--  上传证书-->
              <div class="pop-up" v-show="tanchu1" v-drag="{ handle: '.pop_up_text_Upload' }">
                <!--  上传证书-->
                <div class="pop_up_text pop_up_text_Upload"><span class="span_pad"></span>{{ $t("logs.base10_a1") }}</div>
                <p></p>
                <div class="find">
                  <div class="find1">
                    <!--证书格式 -->
                    <div class="find-text" style="padding-right:12px">
                      {{ $t("logs.base10_a15") }}:
                    </div>
                    <div class="block block1">
                      <el-select v-model="value" placeholder="请选择" @change="Upload_certificate">
                        <el-option
                          v-for="item in options"
                          :key="item.value"
                          :label="item.label"
                          :value="item.value"
                        >
                        </el-option>
                      </el-select>
                    </div>
                  </div>

                  <div class="find1">
                    <!--证书文件 -->
                    <div class="find-text" style="padding-right:12px">
                      {{ $t("logs.base10_a16") }}:
                    </div>
                    <div class="block block1">
                      <input
                        type="file"
                        @change="inputFileChange"
                        id="iupfile"
                        ref="clearFile"
                      />
                    </div>
                  </div>
                  <div class="find1" v-show="this.certificate_password==false">
                    <!--证书私钥 -->
                    <div class="find-text" style="padding-right:12px">
                      {{ $t("logs.base10_a17") }}:
                    </div>
                    <div class="block block1">
                      <input
                        type="file"
                        @change="inputFileChange1"
                        id="iupfile1"
                        ref="clearFile1"
                      />
                    </div>
                  </div>
                      <div class="find1" v-show="this.certificate_password==true">
                    <!--证书密码 -->
                    <div class="find-text" style="padding-right:12px">
                      {{ $t("logs.base10_pass") }}:
                    </div>
                    <div class="block block1">
                       <el-input v-model="pfxpass" placeholder></el-input>
                    </div>
                  </div>
                </div>

                <el-row>
                  <el-button type="primary" @click="upload_cert()" :disabled="$root.jurisdiction.only_query == 0">{{
                    $t("logs.save_a")
                  }}</el-button>
                  <el-button type="danger" @click="tanSend2()">{{
                    $t("logs.save_b")
                  }}</el-button>
                </el-row>
              </div>

              <div class="pop-up" v-show="tanchu" v-drag="{ handle: '.pop_up_text_cert_domain' }">
                <!--  自建证书-->
                <div class="pop_up_text pop_up_text_cert_domain"><span class="span_pad"></span>{{ $t("logs.base10_a2") }}</div>
                <p></p>
                <div class="find">
                  <div class="find1">
                    <!--域名 -->
                    <div class="find-text" style="padding-right:12px">
                      {{ $t("logs.base10_a4") }}:
                    </div>
                    <div class="block block1">
                      <el-input v-model="cert_domain" placeholder=""></el-input>
                    </div>
                  </div>

                  <div class="find1">
                    <!--公司名称 -->
                    <div class="find-text" style="padding-right:12px">
                      {{ $t("logs.base10_a8") }}:
                    </div>
                    <div class="block block1">
                      <el-input
                        v-model="cert_company"
                        placeholder=""
                      ></el-input>
                    </div>
                  </div>
                  <div class="find1">
                    <!--部门 -->
                    <div class="find-text" style="padding-right:12px">
                      {{ $t("logs.base10_a9") }}:
                    </div>
                    <div class="block block1">
                      <el-input v-model="cert_depart" placeholder=""></el-input>
                    </div>
                  </div>
                  <div class="find1">
                    <!--城市 -->
                    <div class="find-text" style="padding-right:12px">
                      {{ $t("logs.base10_a10") }}:
                    </div>
                    <div class="block block1">
                      <el-input v-model="cert_city" placeholder=""></el-input>
                    </div>
                  </div>
                  <div class="find1">
                    <!--省/直辖市 -->
                    <div class="find-text" style="padding-right:12px">
                      {{ $t("logs.base10_a11") }}:
                    </div>
                    <div class="block block1">
                      <el-input
                        v-model="cert_province"
                        placeholder=""
                      ></el-input>
                    </div>
                  </div>
                  <div class="find1">
                    <!--国家 -->
                    <div class="find-text" style="padding-right:12px">
                      {{ $t("logs.base10_a12") }}:
                    </div>
                    <div class="block block1">
                      <el-input
                        v-model="cert_country_name"
                        placeholder=""
                        class="count_city"
                      ></el-input>
                      <span style="font-size:12px;margin-left:10px">{{
                        $t("logs.base10_a13")
                      }}</span>
                    </div>
                  </div>
                  <div class="find1">
                    <!--证书到期时间 -->
                    <div class="find-text" style="padding-right:12px">
                      {{ $t("logs.base10_a7") }}:
                    </div>
                    <div class="block block1">
                      <el-input
                        v-model="cert_time"
                        placeholder=""
                        class="count_city"
                      ></el-input>
                      <span style="font-size:12px;margin-left:10px">{{
                        $t("logs.base10_a14")
                      }}</span>
                    </div>
                  </div>
                </div>

                <el-row>
                  <el-button type="primary" @click="tanSend_table_self()" :disabled="$root.jurisdiction.only_query == 0">{{
                    $t("logs.save_a")
                  }}</el-button>
                  <el-button type="danger" @click="tanSend1()">{{
                    $t("logs.save_b")
                  }}</el-button>
                </el-row>
              </div>
              <div class="gray" v-show="tanchu"></div>
              <div class="gray" v-show="tanchu1"></div>
            </div>
          </div>
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>

<script>
// import $ from "jquery";

export default {
  data() {
    return {
      route_type: 1,
      systime_time: "",
      data_loadok1: "",
      data_loadok2: "",
      data_loadok8: "",
      // 10
      selft_build: true,
      selft_build1: false,
      selft_build2: false,
      selft_build_value: "",
      selft_build_value1: "",
      // 9
      expdate_mac: "",
      expdate: "",
      expdate_license: "",
      // 后台访问控制
      max_login_time: "",
      max_login_err: "",
      super_ip: "",
      super_access: "",
      ip_range: "",
      limit_access: "",
      // license管理
      license: "",
      // 证书管理
      // 7
      ntp_server: "",
      cert_company: "",
      cert_time: "",
      cert_country_name: "",
      cert_province: "",
      cert_city: "",
      cert_depart: "",
      cert_domain: "",
      // cert_time: '',
      // 6
      tls_address: "",
      tls_type: "none",
      tls_typee: [],
      //5
      route_address: "",
      route_ip: "",
      route_port: "",
      route_port_sender: "",
      //4
      local_domain: "",
      // 总数
      totalnums: 0,
      size: 0,
      // 每页条数
      pagesize: 0,
      //   默认前往第几页
      page: 1,
      // 3
      relay_domain: "",
      // 默认域名
      authdomain: "",
      filterdomain: "",
      // 邮件传送

      mtaip: "",
      op_mynetworks: [],
      addordelip: [],
      mydomain: "",
      myhostname: "",
pfxpass:'',
      date: new Date(),
      textarea: "",
      input: "",

      value1: "",

      tableData: [
        {
          address: "44",
        },
      ],
      emali: "",
      value: "1",
      checkList: [],
      tanchu: false,
      tanchu1: false,
      tanchu2: false,
      options: [
        {
          value: "1",
          label: "crt",
        },
        {
          value: "2",
          label: "pfx",
        },
      ],
      certificate_password:false,
      route_port_sender_daful:'',
      checked: [],
      fileList: [],
      fileList3: [],
      fileList4: [],
      fileList5: [],
      fileList5_sender:[],
      fileList6: [],
      fileList10: [],
      radio: "",
      files: "",
      files1: "",
      data_loadok_time: "",
      date_time: "",
      loading: false,
      isbuild: 0,
      data_loadok: "",
      intervalId: null,
      activeName: "",
    };
  },
  created() {
    // if(this.activeName=='load_sys_time'){
    // this.dataRefreh();
    // }
  },
  destroyed() {
    // 在页面销毁后，清除计时器
    this.clear();
  },
  mounted() {
    // this.handleClick_tab();

    this.getFileList1();
    this.getFileList2();
    this.getFileList3();
    this.getFileList4();
    this.getFileList5();
    this.getFileList5_sender();
    this.getFileList6();
    // this.getFileList7();

    this.getFileList8();
    this.getFileList9();
    this.getFileList10();
    // var _this = this; //声明一个变量指向vue实例this,保证作用域一致
    // this.timer = setInterval(function () {
    //     _this.date = new Date(); //修改数据date
    // }, 1000);
  },
  beforeDestroy() {
    if (this.timer) {
      clearInterval(this.timer); //在vue实例销毁钱，清除我们的定时器
    }
  },
  methods: {
    handleClick_tab() {
      // console.log(a.index);
      // console.log(this.activeName);
      if (this.activeName == "load_sys_time") {
        this.getFileList7();

        this.dataRefreh();

        let time_81 = this.systime_time;

        this.dataform(time_81);
        console.log(this.dataform(time_81), this.systime_time);
      } else {
        this.clear();
      }
      // if(a.index==8){
      //   this.activeName=
      // }
    },
    zeroFn(m) {
      return m < 10 ? "0" + m : m;
    }, //补0函数
    dataform(systime_time) {
      // var date = new Date(systime_time);
      var time = new Date(systime_time);
      // console.log(time)
      var y = time.getFullYear();
      var m = time.getMonth() + 1;
      var d = time.getDate();
      var h = time.getHours();
      var mm = time.getMinutes();
      var s = time.getSeconds();
      return (
        y +
        "-" +
        this.zeroFn(m) +
        "-" +
        this.zeroFn(d) +
        " " +
        this.zeroFn(h) +
        ":" +
        this.zeroFn(mm) +
        ":" +
        this.zeroFn(s)
      );
    },

    // 定时刷新数据函数
    dataRefreh() {
      // 计时器正在进行中，退出函数
      if (this.intervalId != null) {
        return;
      }

      // 计时器为空，操作
      this.intervalId = setInterval(() => {
        setTimeout(() => {
          this.systime_time += 1000;
          // console.log(this.systime_time);
        }, 0);
      }, 1000);
    },
    // 停止定时器
    clear() {
      clearInterval(this.intervalId); //清除计时器
      this.intervalId = null; //设置为null
    },
    // 显示
    tan: function() {
      this.tanchu = true;
      this.relay_domain = "";
      this.local_domain = "";
      this.route_address = "";
      this.route_ip = "";
      this.tls_address = "";
      this.tls_type = "none";
      this.route_port=this.route_port_sender_daful
      console.log(this.route_port,this.route_port_sender_daful)
    },
    // 显示
    tan1: function() {
      this.pfxpass='';
      this.value='1';
      this.certificate_password=false;
      this.tanchu1 = true;
    },
    // 打开关闭
    tanSend: function() {
      this.tanchu = false;
    },
    tanSend1: function() {
      this.tanchu = false;
    },
    tanSend2: function() {
      this.tanchu1 = false;
    },
    tanSend_off: function() {
      this.tanchu2 = false;
    },
    tanOff: function() {
      this.tanchu = false;
    },
    // 各行变色
    tableRowClassName({ rowIndex }) {
      // console.log(row,rowIndex)
      if (rowIndex % 2 == 1) {
        return "warning-row";
        // console.log(2222)
      } else if (rowIndex % 2 !== 1) {
        return "success-row";
      }
      return "";
    },

    // 日期
    dateFormat(time) {
      var date = new Date(time);
      var year = date.getFullYear();

      var month =
        date.getMonth() + 1 < 10
          ? "0" + (date.getMonth() + 1)
          : date.getMonth() + 1;
      var day = date.getDate() < 10 ? "0" + date.getDate() : date.getDate();
      var hours =
        date.getHours() < 10 ? "0" + date.getHours() : date.getHours();
      var minutes =
        date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes();
      var seconds =
        date.getSeconds() < 10 ? "0" + date.getSeconds() : date.getSeconds();
      // 拼接
      return (
        year +
        "-" +
        month +
        "-" +
        day +
        "    " +
        hours +
        ":" +
        minutes +
        ":" +
        seconds
      );
    },
    inputFileChange(e) {
      // var file = e.target.files;
      // for (var i = 0; i < file.length; i++) {
      //     //    上传类型判断
      //     var imgName = file[i].name;
      //     var idx = imgName.lastIndexOf(".");
      //     if (idx != -1) {
      //         var ext = imgName.substr(idx + 1).toUpperCase();
      //         console.log(ext)

      //         ext = ext.toLowerCase();
      //         console.log(ext)

      //         // && ext!='doc' && ext!='docx'
      //         if (ext == 'crt' || ext == 'pfx') {
      //             console.log(11)
      //             console.log(file)
      //             console.log(this.files)

      //         } else {
      //             alert('只可以上传txt类型文件')

      //             // this.files = flie;

      //             // this.files.push(file[i]);

      //         }
      //     }

      // }

      this.files = e.target.files[0];
      // console.log(this.files);
    },
    inputFileChange1(e) {
      this.files1 = e.target.files[0];
      // console.log(this.files);
    },
    Upload_certificate(val){
        console.log(val)
        if(val==1){
          this.certificate_password=false

        }else{
          this.certificate_password=true
        }
    },
    // 上传证书配置

    Certificate_Profile2() {
      this.$confirm(`${this.$t("tan.profile")}`, {
        confirmButtonText: `${this.$t("tan.confirm")}`,
        cancelButtonText: `${this.$t("tan.cancel")}`,
        type: "warning",
      })
        .then(() => {
          let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;

          this.$axios
            .get("/api/adm/cgi/newspam.cgi", {
              params: {
                __mode: "config_cert",

                sid: sid,

                // screen: "real_filterlog.html",
              },
            })
            .then((res) => {
              if (!res.data.fmstatus) {
                alert(res.data);
              } else if (res.data.fmstatus.code == "1") {
                alert(res.data.fmstatus.errmsg);
              } else if (res.data.fmstatus.code == "2") {
                alert(res.data.fmstatus.errmsg);
              } else if (res.data.fmstatus.code == "3") {
                // alert(res.data.fmstatus.errmsg);
                this.$router.push({
                  name: "login",
                });
              } else {
                // this.$message({
                //     type: "success",
                //     message: `${this.$t("tan.config_success")}`,
                // });
                this.isbuild = 1;
                this.getFileList10();
              }
              this.selft_build2 = false;
              this.selft_build = true;
              this.tanchu2 = false;
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: `${this.$t("tan.cancel")}`,
          });
          this.selft_build2 = false;
          this.selft_build = true;
          this.tanchu1 = false;
        });
    },
    // upload_cert
    // 上传证书 保存
    upload_cert() {
      let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
      // console.log(sid);

      let iupfile = this.files;
      let iupfile2 = this.files1;
      // console.log(iupfile);
      // 判断是否有文件
      if (0 == this.files.length) {
        this.$message({
          type: "info",
          message: "请选择要上传的文件",
        });
        return;
      } else {
        this.$save_hint_test();
        this.$disable_hint_test();
        this.tanchu = false;
        let cert_format = this.value;
        let fd = new FormData();
        fd.append("iupfile", iupfile);
        fd.append("iupfile2", iupfile2);
        // for (var i = 0; i < this.files.length; i++) {
        //     fd.append('fileUpload', this.files[i]);
        // }
        fd.append("__mode", "upload_cert");
        fd.append("cert_format", cert_format);
        fd.append("sid", sid);
        fd.append("pfxpass", this.pfxpass);
        // console.log(fd);
        this.$axios({
          method: "post",
          url: "/api/adm/cgi/newspam.cgi",
          headers: {
            "Content-Type": "multipart/form-data",
          },
          data: fd,
        }).then((res) => {
          console.log(res);
        this.$close_hint_test();
        this.$close_disable_hint_test();
          if (!res.data.fmstatus) {
            alert(res.data);
          } else if (res.data.fmstatus.code == "1") {
            alert(res.data.fmstatus.errmsg);
            this.$refs.clearFile.value = ""; // 清空file文件
          } else if (res.data.fmstatus.code == "2") {
            alert(res.data.fmstatus.errmsg);
            this.$refs.clearFile.value = ""; // 清空file文件
            this.$refs.clearFile1.value = ""; // 清空file文件

       
          } else if (res.data.fmstatus.code == "3") {
            // alert(res.data.fmstatus.errmsg);
            this.$router.push({
              name: "login",
            });
          } else {
            this.loading = false;
            this.selft_build2 = true;
            this.selft_build = false;
         
            this.$refs.clearFile.value = ""; // 清空file文件
            this.$refs.clearFile1.value = ""; // 清空file文件
            this.files = "";
            this.files1 = "";
            console.log(this.files);
            // this.$message({
            //     type: "success",
            //     message: `${this.$t('anti_gs1_tan.del3')}`,
            // });
          }
      
        });
      }
    },

    // 配置证书

    Certificate_Profile() {
      this.$confirm(`${this.$t("tan.profile")}`, {
        confirmButtonText: `${this.$t("tan.confirm")}`,
        cancelButtonText: `${this.$t("tan.cancel")}`,
        type: "warning",
      })
        .then(() => {
          let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;

          this.$axios
            .get("/api/adm/cgi/newspam.cgi", {
              params: {
                __mode: "selfconfig_cert",

                sid: sid,

                // screen: "real_filterlog.html",
              },
            })
            .then((res) => {
              if (!res.data.fmstatus) {
                alert(res.data);
              } else if (res.data.fmstatus.code == "1") {
                alert(res.data.fmstatus.errmsg);
              } else if (res.data.fmstatus.code == "2") {
                alert(res.data.fmstatus.errmsg);
              } else if (res.data.fmstatus.code == "3") {
                // alert(res.data.fmstatus.errmsg);
                this.$router.push({
                  name: "login",
                });
              } else {
                // this.$message({
                //     type: "success",
                //     message: `${this.$t("tan.config_success")}`,
                // });
                this.isbuild = 1;
                this.getFileList10();
              }
              this.selft_build1 = false;
              this.selft_build = true;
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: `${this.$t("tan.cancel")}`,
          });
          this.selft_build1 = false;
          this.selft_build = true;
        });
    },

    // 证书管理加载
    getFileList10() {
      this.loading = true;

      let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
      // console.log(sid);

      this.$axios
        .get("/api/adm/cgi/newspam.cgi", {
          params: {
            __mode: "load_all_certficate",
            sid: sid,
            isbuild: this.isbuild,
          },
        })
        .then((res) => {
          console.log(res);

          if (!res) {
            this.loading = false;
          } else if (!res.data.fmstatus) {
            alert(res.data);
          } else if (res.data.fmstatus.code == "2") {
            alert(res.data.fmstatus.errmsg);
            this.loading = false;
          } else if (res.data.fmstatus.code == "3") {
            // alert(res.data.fmstatus.errmsg);
            this.$router.push({
              name: "login",
            });
          } else {
            this.loading = false;

            this.fileList10 = res.data.ret.datalist;
            this.cert_country_name = res.data.ret.CERT_COUNTRY_NAME;
            this.cert_time = res.data.ret.CERT_TIME;
            this.selft_build_value = res.data.ret.selfconfig_certficate_hint;
            this.selft_build_value1 = res.data.ret.config_certficate_hint;
            if (res.data.ret.UPLOAD_FAIL == 1) {
              alert(res.data.ret.SHOW_MSG);
            } else if (res.data.ret.UPLOAD_FAIL == 0) {
              this.$message({
                type: "success",
                message: `${res.data.ret.SHOW_MSG}`,
              });
            }
            //
          }
        });
    },
    //  自建证书保存
    tanSend_table_self() {
      // this.loading = true;
      this.$save_hint_test();
      this.$disable_hint_test();
      let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
      // console.log(sid);

      // console.log(col, '5555')
      let str = this.$qs.stringify({
        __mode: "save_certficate",
        sid: sid,
        cert_domain: this.cert_domain,
        cert_company: this.cert_company,
        cert_depart: this.cert_depart,
        cert_city: this.cert_city,
        cert_province: this.cert_province,
        cert_country_name: this.cert_country_name,
        cert_time: this.cert_time,
        // limit_access: this.limit_access == true ? 1 : 0,
        // super_access: this.super_access == true ? 1 : 0,
        // ip_range: this.ip_range,
        // super_ip: this.ip_range,
        // max_login_err: this.max_login_err,
        // max_login_time: this.max_login_time
      });
      this.$axios
        .post(
          "/api/adm/cgi/newspam.cgi",
          str
          // screen: "real_filterlog.html",
        )
        .then((res) => {
          // console.log(res);
this.$close_hint_test();
this.$close_disable_hint_test();
          if (!res.data.fmstatus) {
            alert(res.data);
          } else if (res.data.fmstatus.code == "1") {
            alert(res.data.fmstatus.errmsg);
          } else if (res.data.fmstatus.code == "2") {
            alert(res.data.fmstatus.errmsg);
          } else if (res.data.fmstatus.code == "3") {
            // alert(res.data.fmstatus.errmsg);
            this.$router.push({
              name: "login",
            });
          } else {
            this.tanchu = false;

            this.loading = false;
            this.selft_build1 = true;
            this.selft_build = false;
            // this.$message({
            //     type: "success",
            //     message: `${this.$t('anti_gs1_tan.save_sueecss')}`,
            // });
          }
        });
    },
    // License管理 加载
    getFileList9() {
      this.loading = true;

      let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
      // console.log(sid);

      this.$axios
        .get("/api/adm/cgi/newspam.cgi", {
          params: {
            __mode: "load_license",
            sid: sid,
          },
        })
        .then((res) => {
          // console.log(res);

          if (!res) {
            this.loading = false;
          } else if (!res.data.fmstatus) {
            alert(res.data);
          } else if (res.data.fmstatus.code == "2") {
            alert(res.data.fmstatus.errmsg);
            this.loading = false;
         
          } else if (res.data.fmstatus.code == "3") {
            // alert(res.data.fmstatus.errmsg);
            this.$router.push({
              name: "login",
            });
          } else {
            this.loading = false;

            this.expdate_mac = res.data.ret.mac;
            this.expdate = res.data.ret.expdate;
            this.expdate_license = res.data.ret.ok;
            // this.tls_typee = res.data.ret.q_tls_type

            //
          }
        });
    },
    // License管理保存
    tanSend_table9() {
      // this.loading = true;
      this.$save_hint_test();
      this.$disable_hint_test();
      this.tanchu = false;
      let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
      // console.log(sid);

      // console.log(col, '5555')
      let str = this.$qs.stringify({
        __mode: "save_license",
        sid: sid,
        data_loadok: this.expdate_license,
        license: this.license,
      });
      this.$axios
        .post(
          "/api/adm/cgi/newspam.cgi",
          str
          // screen: "real_filterlog.html",
        )
        .then((res) => {
          // console.log(res);
          this.$close_hint_test();
          this.$close_disable_hint_test();
          if (!res.data.fmstatus) {
            alert(res.data);
          } else if (res.data.fmstatus.code == "1") {
            alert(res.data.fmstatus.errmsg);
          } else if (res.data.fmstatus.code == "2") {
            alert(res.data.fmstatus.errmsg);
          } else if (res.data.fmstatus.code == "3") {
            // alert(res.data.fmstatus.errmsg);
            this.$router.push({
              name: "login",
            });
          } else {
            this.loading = false;
            this.getFileList9();
            this.$message({
              type: "success",
              message: `${this.$t("anti_gs1_tan.save_sueecss")}`,
            });
          }
        });
    },
    // 后台访问控制 加载
    getFileList8() {
      this.loading = true;

      let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
      // console.log(sid);

      this.$axios
        .get("/api/adm/cgi/newspam.cgi", {
          params: {
            __mode: "load_ip_priv",
            sid: sid,
          },
        })
        .then((res) => {
          // console.log(res);

          if (!res) {
            this.loading = false;
          } else if (!res.data.fmstatus) {
            alert(res.data);
          } else if (res.data.fmstatus.code == "2") {
            alert(res.data.fmstatus.errmsg);
            this.loading = false;
           
          } else if (res.data.fmstatus.code == "3") {
            // alert(res.data.fmstatus.errmsg);
            this.$router.push({
              name: "login",
            });
          } else {
            this.loading = false;
            this.limit_access =
              res.data.ret.result.SYS_LIMIT_WEB_ACCESS == 0
                ? (this.limit_access = false)
                : true;
            this.super_access =
              res.data.ret.result.SYS_CAN_CFG_NETWORK == 0
                ? (this.super_access = false)
                : true;
            this.ip_range = res.data.ret.result.SYS_LIMIT_WEB_ACCESS_IP;
            this.super_ip = res.data.ret.result.SYS_CFG_NETWORK_IPRANGE;
            this.max_login_err = res.data.ret.result.SYS_LOGIN_ERR_MAX;
            this.max_login_time = res.data.ret.result.FM_WEB_ERR_DURATION;
            this.data_loadok8 = res.data.ret.ok;
            // this.fileList6 = res.data.ret.datalist;
            // this.tls_typee = res.data.ret.q_tls_type

            //
          }
        });
    },
    // 后台访问控制保存
    tanSend_table8() {
      // this.loading = true;
      this.$save_hint_test();
      this.$disable_hint_test();
      this.tanchu = false;
      let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
      // console.log(sid);

      // console.log(col, '5555')
      let str = this.$qs.stringify({
        __mode: "save_ip_priv",
        sid: sid,
        limit_access: this.limit_access == true ? 1 : 0,
        super_access: this.super_access == true ? 1 : 0,
        ip_range: this.ip_range,
        super_ip: this.ip_range,
        max_login_err: this.max_login_err,
        max_login_time: this.max_login_time,
        data_loadok: this.data_loadok8,
      });
      this.$axios
        .post(
          "/api/adm/cgi/newspam.cgi",
          str
          // screen: "real_filterlog.html",
        )
        .then((res) => {
          console.log(res);
this.$close_hint_test();
this.$close_disable_hint_test();
          if (!res.data.fmstatus) {
            alert(res.data);
          } else if (res.data.fmstatus.code == "1") {
            alert(res.data.fmstatus.errmsg);
          } else if (res.data.fmstatus.code == "2") {
            alert(res.data.fmstatus.errmsg);
          } else if (res.data.fmstatus.code == "3") {
            alert(res.data.fmstatus.errmsg);
            // this.$router.push({
            //     name: "login",
            // });
          } else {
            this.loading = false;
            this.getFileList8();
            this.$message({
              type: "success",
              message: `${this.$t("anti_gs1_tan.save_sueecss")}`,
            });
          }
        });
    },
    // 时间 加载
    getFileList7() {
      this.loading = true;

      let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
      // console.log(sid);

      this.$axios
        .get("/api/adm/cgi/newspam.cgi", {
          params: {
            __mode: "load_sys_time",
            sid: sid,
          },
        })
        .then((res) => {
          console.log(res);

          if (!res.data.fmstatus) {
            alert(res.data);
          } else if (res.data.fmstatus.code == "1") {
            alert(res.data.fmstatus.errmsg);
           
          } else if (res.data.fmstatus.code == "2") {
            alert(res.data.fmstatus.errmsg);
           
          } else if (res.data.fmstatus.code == "3") {
            alert(res.data.fmstatus.errmsg);
            this.$router.push({
              name: "login",
            });
          } else {
            // console.log("我早都给你");
            this.loading = false;
            this.ntp_server = res.data.ret.NTP_SERVER;
            this.data_loadok_time = res.data.ret.data_loadok;
            // this.systime_time =new Date(res.data.ret.SYSTIME).getTime();
            this.systime_time = JSON.parse(res.data.ret.SYSTIME);
            console.log(this.systime_time);
          }
        });
    },
    // 时间  手动设置 保存
    tanSend_table_time() {
      console.log(this.date_time);
      if (this.date_time == "") {
        this.$message({
          type: "success",
          message: `${this.$t("anti_gs1_tan.select_time")}`,
        });
      } else {
        // this.loading = true;
        this.tanchu = false;
        let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
        // console.log(sid);

        // console.log(col, '5555')
        let str = this.$qs.stringify({
          __mode: "save_sys_time",
          sid: sid,
          date: this.date_time,
        });
        // console.log(str)
        this.$axios
          .post(
            "/api/adm/cgi/newspam.cgi",
            str

            // screen: "real_filterlog.html",
          )
          .then((res) => {
            // console.log(res);

            if (!res.data.fmstatus) {
              alert(res.data);
            } else if (res.data.fmstatus.code == "1") {
              alert(res.data.fmstatus.errmsg);
            } else if (res.data.fmstatus.code == "2") {
              alert(res.data.fmstatus.errmsg);
            } else if (res.data.fmstatus.code == "3") {
              // alert(res.data.fmstatus.errmsg);
              this.$router.push({
                name: "login",
              });
            } else {
              this.loading = false;

              this.getFileList7();
              this.$message({
                type: "success",
                message: `${this.$t("anti_gs1_tan.save_sueecss")}`,
              });
            }
          })
          .catch((err) => {
            console.log("接口错误");
            console.log(err);
            alert(err);
          });
      }
    },
    // 时间  同步 保存
    tanSend_table_ntp() {
      // this.loading = true;
      this.tanchu = false;
      let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
      // console.log(sid);

      // console.log(col, '5555')
      let str = this.$qs.stringify({
        __mode: "rsync_sys_time",
        sid: sid,
        ntp_server: this.ntp_server,
        data_loadok: this.data_loadok_time,
      });
      this.$axios
        .post(
          "/api/adm/cgi/newspam.cgi",
          str
          // screen: "real_filterlog.html",
        )
        .then((res) => {
          // console.log(res);

          if (!res.data.fmstatus) {
            alert(res.data);
          } else if (res.data.fmstatus.code == "1") {
            alert(res.data.fmstatus.errmsg);
          } else if (res.data.fmstatus.code == "2") {
            alert(res.data.fmstatus.errmsg);
          } else if (res.data.fmstatus.code == "3") {
            // alert(res.data.fmstatus.errmsg);
            this.$router.push({
              name: "login",
            });
          } else {
            this.loading = false;
            this.getFileList7();
            this.$message({
              type: "success",
              message: `${this.$t("anti_gs1_tan.save_sueecss")}`,
            });
          }
        });
    },
    // TLS设置 加载
    getFileList6() {
      this.loading = true;

      let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
      // console.log(sid);

      this.$axios
        .get("/api/adm/cgi/newspam.cgi", {
          params: {
            __mode: "load_all_tls",
            sid: sid,
          },
        })
        .then((res) => {
          // console.log(res);

          if (!res) {
            this.loading = false;
          } else if (!res.data.fmstatus) {
            alert(res.data);
          } else if (res.data.fmstatus.code == "2") {
            alert(res.data.fmstatus.errmsg);
            this.loading = false;
           
          } else if (res.data.fmstatus.code == "3") {
            // alert(res.data.fmstatus.errmsg);
            this.$router.push({
              name: "login",
            });
          } else {
            this.loading = false;
            this.fileList6 = res.data.ret.datalist;
            this.tls_typee = res.data.ret.q_tls_type;

            //
          }
        });
    },
    // TLS设置 保存
    tanSend_table6() {
      // this.loading = true;
      this.$save_hint_test();
      this.$disable_hint_test();
      let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
      // console.log(sid);

      // console.log(col, '5555')
      let str = this.$qs.stringify({
        __mode: "save_all_tls",
        sid: sid,
        tls_address: this.tls_address,
        tls_type: this.tls_type,
      });
      this.$axios
        .post(
          "/api/adm/cgi/newspam.cgi",
          str
          // screen: "real_filterlog.html",
        )
        .then((res) => {
          // console.log(res);
this.$close_hint_test();
this.$close_disable_hint_test();
          if (!res.data.fmstatus) {
            alert(res.data);
          } else if (res.data.fmstatus.code == "1") {
            alert(res.data.fmstatus.errmsg);
          } else if (res.data.fmstatus.code == "2") {
            alert(res.data.fmstatus.errmsg);
          } else if (res.data.fmstatus.code == "3") {
            // alert(res.data.fmstatus.errmsg);
            this.$router.push({
              name: "login",
            });
          } else {
            this.tanchu = false;
            this.loading = false;
            this.getFileList6();
            this.$message({
              type: "success",
              message: `${this.$t("anti_gs1_tan.del3")}`,
            });
            this.route_address = "";
            this.route_ip = "";
          }
        });
    },
    // TLS设置 删除
    handleClick6(index, scope) {
      // console.log(index, scope)
      this.$confirm(`${this.$t("anti_gs1_tan.del")}`, {
        confirmButtonText: `${this.$t("tan.confirm")}`,
        cancelButtonText: `${this.$t("tan.cancel")}`,
        type: "warning",
      })
        .then(() => {
          this.loading = true;
          let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;

          let tls_address = scope.TLS_ADDRESS;
          let str = this.$qs.stringify({
            __mode: "del_tls",
            sid: sid,
            tls_address: tls_address,
          });
          this.$axios.post("/api/adm/cgi/newspam.cgi", str).then((res) => {
            // console.log(res);

            if (!res) {
              this.loading = false;
            } else if (!res.data.fmstatus) {
              alert(res.data);
            } else if (res.data.fmstatus.code == "1") {
              alert(res.data.fmstatus.errmsg);
            } else if (res.data.fmstatus.code == "2") {
              alert(res.data.fmstatus.errmsg);
              this.loading = false;
              // this.getFileList();
            } else if (res.data.fmstatus.code == "3") {
              // alert(res.data.fmstatus.errmsg);
              this.$router.push({
                name: "login",
              });
            } else {
              this.loading = false;
              this.getFileList6();
              this.$message({
                type: "success",
                message: `${this.$t("anti_gs1_tan.del1")}`,
              });
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: `${this.$t("anti_gs1_tan.del2")}`,
          });
        });
    },
       // 发件人路由设置 加载
    getFileList5_sender() {
      this.loading = true;

      let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
      // console.log(sid);

      this.$axios
        .get("/api/adm/cgi/bspam.cgi", {
          params: {
            __mode: "load_sender_relay",
            sid: sid,
          },
        })
        .then((res) => {
          console.log(res);

          if (!res) {
            this.loading = false;
          } else if (!res.data.fmstatus) {
            alert(res.data);
          } else if (res.data.fmstatus.code == "2") {
            alert(res.data.fmstatus.errmsg);
            this.loading = false;
           
          } else if (res.data.fmstatus.code == "3") {
            // alert(res.data.fmstatus.errmsg);
            this.$router.push({
              name: "login",
            });
          } else {
            this.loading = false;
            this.fileList5_sender = res.data.ret.datalist;
            this.route_port_sender = res.data.ret.ROUTE_PORT;
            this.route_port_sender_daful = res.data.ret.RELAY_PORT;
            //
          }
        });
    },
    // 路由设置 加载
    getFileList5() {
      this.loading = true;

      let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
      // console.log(sid);

      this.$axios
        .get("/api/adm/cgi/newspam.cgi", {
          params: {
            __mode: "load_all_routes",
            sid: sid,
          },
        })
        .then((res) => {
          // console.log(res);

          if (!res) {
            this.loading = false;
          } else if (!res.data.fmstatus) {
            alert(res.data);
          } else if (res.data.fmstatus.code == "2") {
            alert(res.data.fmstatus.errmsg);
            this.loading = false;
           
          } else if (res.data.fmstatus.code == "3") {
            // alert(res.data.fmstatus.errmsg);
            this.$router.push({
              name: "login",
            });
          } else {
            this.loading = false;
            this.fileList5 = res.data.ret.datalist;
            this.route_port = res.data.ret.ROUTE_PORT;
            //
          }
        });
    },
     // 发件人路由设置 保存
    tanSend_table5_sender() {
      
      this.$save_hint_test()
      this.$disable_hint_test();
      let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
      // console.log(sid);

      // console.log(col, '5555')
      let str = this.$qs.stringify({
        __mode: "save_sender_relay",
        sid: sid,
         sender: this.route_address,
         relay_ip: this.route_ip,
       relay_port: this.route_port,
        // relay_type: this.route_type,

        newadd: 1,
      });
      this.$axios
        .post(
          "/api/adm/cgi/bspam.cgi",
          str
          // screen: "real_filterlog.html",
        )
        .then((res) => {
          // console.log(res);
      // this.tanchu = false;
this.$close_disable_hint_test();
                        this.$close_hint_test()
                  
          if (!res) {
            this.loading = false;
          } else if (!res.data.fmstatus) {
            alert(res.data);
          } else if (res.data.fmstatus.code == "1") {
            alert(res.data.fmstatus.errmsg);
          } else if (res.data.fmstatus.code == "2") {
            alert(res.data.fmstatus.errmsg);
            this.loading = false;
          } else if (res.data.fmstatus.code == "3") {
            // alert(res.data.fmstatus.errmsg);
            this.$router.push({
              name: "login",
            });
          } else {
            this.tanchu = false;
            this.loading = false;
            this.getFileList5_sender();
            this.$message({
              type: "success",
              message: `${this.$t("anti_gs1_tan.del3")}`,
            });
           
          }
        });
    },
    // 路由设置 保存
    tanSend_table5() {
     this.$save_hint_test();
            this.$disable_hint_test();
      let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
      // console.log(sid);

      // console.log(col, '5555')
      let str = this.$qs.stringify({
        __mode: "save_all_route",
        sid: sid,
        route_address: this.route_address,
        route_ip: this.route_ip,
        route_port: this.route_port,
        route_type: this.route_type,

        newadd: 1,
      });
      this.$axios
        .post(
          "/api/adm/cgi/newspam.cgi",
          str
          // screen: "real_filterlog.html",
        )
        .then((res) => {
          // console.log(res);
          this.$close_disable_hint_test();
          this.$close_hint_test();

          if (!res) {
            this.loading = false;
          } else if (!res.data.fmstatus) {
            alert(res.data);
          } else if (res.data.fmstatus.code == "1") {
            alert(res.data.fmstatus.errmsg);
          } else if (res.data.fmstatus.code == "2") {
            alert(res.data.fmstatus.errmsg);
            this.loading = false;
          } else if (res.data.fmstatus.code == "3") {
            // alert(res.data.fmstatus.errmsg);
            this.$router.push({
              name: "login",
            });
          } else {
      this.tanchu = false;

            this.loading = false;
            this.getFileList5();
            this.$message({
              type: "success",
              message: `${this.$t("anti_gs1_tan.del3")}`,
            });
            this.route_address = "";
            this.route_ip = "";
          }
        });
    },
    // 发件人路由设置编辑路由设置 删除
    handleClick5_sender(index, scope) {
      console.log(index, scope)
      this.$confirm(`${this.$t("anti_gs1_tan.del")}`, {
        confirmButtonText: `${this.$t("tan.confirm")}`,
        cancelButtonText: `${this.$t("tan.cancel")}`,
        type: "warning",
      })
        .then(() => {
          this.loading = true;
          let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;

          let route_address = scope.SENDER;
          let str = this.$qs.stringify({
        __mode: "del_sender_relay",
           
            sid: sid,
            sender: route_address,
          });
          this.$axios.post("/api/adm/cgi/bspam.cgi", str).then((res) => {
            // console.log(res);

            if (!res) {
              this.loading = false;
            } else if (!res.data.fmstatus) {
              alert(res.data);
            } else if (res.data.fmstatus.code == "1") {
              alert(res.data.fmstatus.errmsg);
            } else if (res.data.fmstatus.code == "2") {
              alert(res.data.fmstatus.errmsg);
              this.loading = false;
              // this.getFileList();
            } else if (res.data.fmstatus.code == "3") {
              alert(res.data.fmstatus.errmsg);
              this.$router.push({
                name: "login",
              });
            } else {
              this.loading = false;
              this.getFileList5_sender();
              this.$message({
                type: "success",
                message: `${this.$t("anti_gs1_tan.del1")}`,
              });
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: `${this.$t("anti_gs1_tan.del2")}`,
          });
        });
    },
      //发件人路由设置编辑
    save05_sender(index, scope) {
      console.log(index, scope);
      this.tanchu2 = true;
      this.route_port = scope.RELAY_PORT;
      this.route_ip = scope.RELAY_IP;
      this.route_address = scope.SENDER;
      this.route_type= scope.RELAY_TYPE;
    },
    // 路由设置 删除
    handleClick5(index, scope) {
      // console.log(index, scope)
      this.$confirm(`${this.$t("anti_gs1_tan.del")}`, {
        confirmButtonText: `${this.$t("tan.confirm")}`,
        cancelButtonText: `${this.$t("tan.cancel")}`,
        type: "warning",
      })
        .then(() => {
          this.loading = true;
          let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;

          let route_address = scope.ROUTE_ADDRESS;
          let str = this.$qs.stringify({
            __mode: "del_route",
            sid: sid,
            route_address: route_address,
          });
          this.$axios.post("/api/adm/cgi/newspam.cgi", str).then((res) => {
            // console.log(res);

            if (!res) {
              this.loading = false;
            } else if (!res.data.fmstatus) {
              alert(res.data);
            } else if (res.data.fmstatus.code == "1") {
              alert(res.data.fmstatus.errmsg);
            } else if (res.data.fmstatus.code == "2") {
              alert(res.data.fmstatus.errmsg);
              this.loading = false;
              // this.getFileList();
            } else if (res.data.fmstatus.code == "3") {
              alert(res.data.fmstatus.errmsg);
              this.$router.push({
                name: "login",
              });
            } else {
              this.loading = false;
              this.getFileList5();
              this.$message({
                type: "success",
                message: `${this.$t("anti_gs1_tan.del1")}`,
              });
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: `${this.$t("anti_gs1_tan.del2")}`,
          });
        });
    },
    //路由设置编辑
    save05(index, scope) {
      // console.log(index, scope);
      this.tanchu2 = true;
      this.route_port = scope.ROUTE_PORT;
      this.route_ip = scope.ROUTE_IP;
      this.route_address = scope.ROUTE_ADDRESS;
      this.route_type= scope.ROUTE_TYPE;
    },
      // 路由设置  编辑保存
    tanSend_table5_save_sender() {
      const close_hint = this.$message({
                message: `${this.$t("anti_gs1_tan.save_load")}`,
                type: 'warning',
                showClose: true,
                duration: 0,
            });
      let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
      // console.log(sid);

      // console.log(col, '5555')
      let str = this.$qs.stringify({
        __mode: "save_sender_relay",
        sid: sid,
         sender: this.route_address,
         relay_ip: this.route_ip,
       relay_port: this.route_port,
        relay_type: this.route_type,
        newadd: 0,
      });
      // console.log(str, '编辑')
      this.$axios
        .post(
          "/api/adm/cgi/bspam.cgi",
          str
          // screen: "real_filterlog.html",
        )
        .then((res) => {
          // console.log(res);
 setTimeout(() => {
                        close_hint.close()
                    });
          if (!res) {
            this.loading = false;
          } else if (!res.data.fmstatus) {
            alert(res.data);
          } else if (res.data.fmstatus.code == "1") {
            alert(res.data.fmstatus.errmsg);
          } else if (res.data.fmstatus.code == "2") {
            alert(res.data.fmstatus.errmsg);
            this.loading = false;
          } else if (res.data.fmstatus.code == "3") {
            // alert(res.data.fmstatus.errmsg);
            this.$router.push({
              name: "login",
            });
          } else {
            
            this.tanchu2 = false;
            this.loading = false;
            this.getFileList5_sender();
            this.$message({
              type: "success",
              message: `${this.$t("anti_gs1_tan.save_sueecss")}`,
            });
            // this.route_address = ''
            // this.route_ip = ''
          }
        });
    },
    // 路由设置  编辑保存
    tanSend_table5_save() {
    this.$save_hint_test();
   this.$disable_hint_test();
      let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
      // console.log(sid);

      // console.log(col, '5555')
      let str = this.$qs.stringify({
        __mode: "save_all_route",
        sid: sid,
        route_address: this.route_address,
        route_ip: this.route_ip,
        route_port: this.route_port,
        route_type: this.route_type,
        newadd: 0,
      });
      // console.log(str, '编辑')
      this.$axios
        .post(
          "/api/adm/cgi/newspam.cgi",
          str
          // screen: "real_filterlog.html",
        )
        .then((res) => {
this.$close_hint_test();
this.$close_disable_hint_test();
          if (!res) {
            this.loading = false;
          } else if (!res.data.fmstatus) {
            alert(res.data);
          } else if (res.data.fmstatus.code == "1") {
            alert(res.data.fmstatus.errmsg);
          } else if (res.data.fmstatus.code == "2") {
            alert(res.data.fmstatus.errmsg);
            this.loading = false;
          } else if (res.data.fmstatus.code == "3") {
            // alert(res.data.fmstatus.errmsg);
            this.$router.push({
              name: "login",
            });
          } else {
            this.tanchu2 = false;
            this.loading = false;
            this.getFileList5();
            this.$message({
              type: "success",
              message: `${this.$t("anti_gs1_tan.save_sueecss")}`,
            });
            // this.route_address = ''
            // this.route_ip = ''
          }
        });
    },
    // 本地域名 加载
    getFileList4() {
      this.loading = true;

      let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
      // console.log(sid);

      this.$axios
        .get("/api/adm/cgi/newspam.cgi", {
          params: {
            __mode: "load_all_local_domain",
            sid: sid,
            page: this.page,
            pagesize: this.pagesize,
          },
        })
        .then((res) => {
          console.log(res);

          if (!res) {
            this.loading = false;
          } else if (!res.data.fmstatus) {
            alert(res.data);
          } else if (res.data.fmstatus.code == "2") {
            alert(res.data.fmstatus.errmsg);
            this.loading = false;
           
          } else if (res.data.fmstatus.code == "3") {
            // alert(res.data.fmstatus.errmsg);
            this.$router.push({
              name: "login",
            });
          } else {
            this.loading = false;
            this.fileList4 = res.data.ret.datalist;
            // 总条数
            this.totalnums = res.data.ret.totalnums;
            this.size = res.data.ret.pagesize;
            this.page = res.data.ret.page;
            this.$nextTick(() => {
              this.$refs.multipleTable4.bodyWrapper.scrollTop = 0;
            });
            //
          }
        });
    },
    // 每页显示多少条 -- 切换
    handleSizeChange(val) {
      // this.col = this.col_search;
      // this.col.pagesize = val;
      this.pagesize = val;

      // console.log(this.col, "给后台返回数据2");

      this.getFileList4();
    },
    // 当前第几页
    handleCurrentChange(val) {
      // console.log(`当前页: ${val}`);
      // this.col = this.col_search;
      // this.col.page = val;
      this.page = val;

      this.getFileList4();
    },
    // 本地域名 保存
    tanSend_table4() {
     this.$save_hint_test();
     this.$disable_hint_test();
      let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
      // console.log(sid);

      // console.log(col, '5555')
      let str = this.$qs.stringify({
        __mode: "save_all_local_domain",
        sid: sid,
        local_domain: this.local_domain,
      });
      this.$axios
        .post(
          "/api/adm/cgi/newspam.cgi",
          str
          // screen: "real_filterlog.html",
        )
        .then((res) => {
          // console.log(res);
            this.$close_hint_test();
            this.$close_disable_hint_test();
          if (!res) {
            this.loading = false;
          } else if (!res.data.fmstatus) {
            alert(res.data);
          } else if (res.data.fmstatus.code == "1") {
            alert(res.data.fmstatus.errmsg);
          } else if (res.data.fmstatus.code == "2") {
            alert(res.data.fmstatus.errmsg);
            this.loading = false;
          } else if (res.data.fmstatus.code == "3") {
            // alert(res.data.fmstatus.errmsg);
            this.$router.push({
              name: "login",
            });
          } else {
      this.tanchu = false;

            this.loading = false;
            this.getFileList4();
            this.$message({
              type: "success",
              message: `${this.$t("anti_gs1_tan.del3")}`,
            });
          }
        });
    },
    // 本地域名 删除
    handleClick4(index, scope) {
      // console.log(index, scope)
      this.$confirm(`${this.$t("anti_gs1_tan.del")}`, {
        confirmButtonText: `${this.$t("tan.confirm")}`,
        cancelButtonText: `${this.$t("tan.cancel")}`,
        type: "warning",
      })
        .then(() => {
          this.loading = true;
          let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;

          let local_domain = scope.LOCAL_DOMAIN;
          let str = this.$qs.stringify({
            __mode: "del_local_domain",
            sid: sid,
            local_domain: local_domain,
          });
          this.$axios.post("/api/adm/cgi/newspam.cgi", str).then((res) => {
            // console.log(res);

            if (!res) {
              this.loading = false;
            } else if (!res.data.fmstatus) {
              alert(res.data);
            } else if (res.data.fmstatus.code == "1") {
              alert(res.data.fmstatus.errmsg);
            } else if (res.data.fmstatus.code == "2") {
              alert(res.data.fmstatus.errmsg);
              this.loading = false;
              // this.getFileList();
            } else if (res.data.fmstatus.code == "3") {
              // alert(res.data.fmstatus.errmsg);
              this.$router.push({
                name: "login",
              });
            } else {
              this.loading = false;
              this.getFileList4();
              this.$message({
                type: "success",
                message: `${this.$t("anti_gs1_tan.del1")}`,
              });
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: `${this.$t("anti_gs1_tan.del2")}`,
          });
        });
    },
    // 中继域名 加载
    getFileList3() {
      this.loading = true;

      let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
      // console.log(sid);

      this.$axios
        .get("/api/adm/cgi/newspam.cgi", {
          params: {
            __mode: "load_all_relay_domain",
            sid: sid,
          },
        })
        .then((res) => {
          // console.log(res);

          if (!res) {
            this.loading = false;
          } else if (!res.data.fmstatus) {
            alert(res.data);
          } else if (res.data.fmstatus.code == "2") {
            alert(res.data.fmstatus.errmsg);
            this.loading = false;
           
          } else if (res.data.fmstatus.code == "3") {
            // alert(res.data.fmstatus.errmsg);
            this.$router.push({
              name: "login",
            });
          } else {
            this.loading = false;
            this.fileList3 = res.data.ret.datalist;
            //
          }
        });
    },
    // 中继域名 保存
    tanSend_table3() {
     this.$save_hint_test();
     this.$disable_hint_test();
      let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
      // console.log(sid);

      // console.log(col, '5555')
      let str = this.$qs.stringify({
        __mode: "save_all_relay_domain",
        sid: sid,
        relay_domain: this.relay_domain,
      });
      this.$axios
        .post(
          "/api/adm/cgi/newspam.cgi",
          str
          // screen: "real_filterlog.html",
        )
        .then((res) => {
          // console.log(res);
        this.$close_hint_test();
        this.$close_disable_hint_test();
          if (!res) {
            this.loading = false;
          } else if (!res.data.fmstatus) {
            alert(res.data);
          } else if (res.data.fmstatus.code == "1") {
            alert(res.data.fmstatus.errmsg);
          } else if (res.data.fmstatus.code == "2") {
            alert(res.data.fmstatus.errmsg);
            this.loading = false;
          } else if (res.data.fmstatus.code == "3") {
            // alert(res.data.fmstatus.errmsg);
            this.$router.push({
              name: "login",
            });
          } else {
      this.tanchu = false;

            this.loading = false;
            this.getFileList3();
            this.$message({
              type: "success",
              message: `${this.$t("anti_gs1_tan.del3")}`,
            });
          }
        });
    },
    // 中继域名 删除
    handleClick3(index, scope) {
      // console.log(index, scope)
      this.$confirm(`${this.$t("anti_gs1_tan.del")}`, {
        confirmButtonText: `${this.$t("tan.confirm")}`,
        cancelButtonText: `${this.$t("tan.cancel")}`,
        type: "warning",
      })
        .then(() => {
          this.loading = true;
          let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;

          let relay_domain = scope.RELAY_DOMAIN;
          let str = this.$qs.stringify({
            __mode: "del_relay_domain",
            sid: sid,
            relay_domain: relay_domain,
          });
          this.$axios.post("/api/adm/cgi/newspam.cgi", str).then((res) => {
            // console.log(res);

            if (!res) {
              this.loading = false;
            } else if (!res.data.fmstatus) {
              alert(res.data);
            } else if (res.data.fmstatus.code == "1") {
              alert(res.data.fmstatus.errmsg);
            } else if (res.data.fmstatus.code == "2") {
              alert(res.data.fmstatus.errmsg);
              this.loading = false;
              // this.getFileList();
            } else if (res.data.fmstatus.code == "3") {
              // alert(res.data.fmstatus.errmsg);
              this.$router.push({
                name: "login",
              });
            } else {
              this.loading = false;
              this.getFileList3();
              this.$message({
                type: "success",
                message: `${this.$t("anti_gs1_tan.del1")}`,
              });
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: `${this.$t("anti_gs1_tan.del2")}`,
          });
        });
    },
    // 基础配置  ，默认域名加载
    getFileList2() {
      this.loading = true;

      let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
      // console.log(sid);

      this.$axios
        .get("/api/adm/cgi/newspam.cgi", {
          params: {
            __mode: "load_default_domain",
            sid: sid,
          },
        })
        .then((res) => {
          // console.log(res);

          if (!res) {
            this.loading = false;
          } else if (!res.data.fmstatus) {
            alert(res.data);
          } else if (res.data.fmstatus.code == "2") {
            alert(res.data.fmstatus.errmsg);
            this.loading = false;
          } else if (res.data.fmstatus.code == "3") {
            // alert(res.data.fmstatus.errmsg);
            this.$router.push({
              name: "login",
            });
          } else {
            this.loading = false;
            this.data_loadok2 = res.data.ret.data_loadok;
            this.authdomain = res.data.ret.result.authdomain;
            this.filterdomain = res.data.ret.result.filterdomain;
          }
        });
    },
    // 默认域名保存
    tanSend_table1() {
      this.loading = true;

      let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
      // console.log(sid);

      // console.log(col, '5555')
      let str = this.$qs.stringify({
        __mode: "save_default_domain",
        sid: sid,
        filterdomain: this.filterdomain,
        authdomain: this.authdomain,

        data_loadok: this.data_loadok2,
      });
      this.$axios
        .post(
          "/api/adm/cgi/newspam.cgi",
          str
          // screen: "real_filterlog.html",
        )
        .then((res) => {
          // console.log(res);

          if (!res) {
            this.loading = false;
          } else if (!res.data.fmstatus) {
            alert(res.data);
          } else if (res.data.fmstatus.code == "1") {
            alert(res.data.fmstatus.errmsg);
          } else if (res.data.fmstatus.code == "2") {
            alert(res.data.fmstatus.errmsg);
            this.loading = false;
          } else if (res.data.fmstatus.code == "3") {
            // alert(res.data.fmstatus.errmsg);
            this.$router.push({
              name: "login",
            });
          } else {
            this.loading = false;
            this.getFileList2();
            this.$message({
              type: "success",
              message: `${this.$t("anti_gs1_tan.save_sueecss")}`,
            });
          }
        });
    },
    // 基础配置  ，邮件传送加载
    getFileList1() {
      this.loading = true;

      let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
      // console.log(sid);

      this.$axios
        .get("/api/adm/cgi/newspam.cgi", {
          params: {
            __mode: "load_main_cf",
            sid: sid,
          },
        })
        .then((res) => {
          console.log(res);

          if (!res) {
            this.loading = false;
          } else if (!res.data.fmstatus) {
            alert(res.data);
          } else if (res.data.fmstatus.code == "2") {
            alert(res.data.fmstatus.errmsg);
            this.loading = false;
            // this.getFileList();
          } else if (res.data.fmstatus.code == "3") {
            alert(res.data.fmstatus.errmsg);
            this.$router.push({
              name: "login",
            });
          } else {
            this.loading = false;
            this.fileList = res.data.ret.result.datalist;
            this.mydomain = res.data.ret.result.mydomain;
            this.myhostname = res.data.ret.result.myhostname;
            this.data_loadok1 = res.data.ret.ok;
            console.log("有没有调用我啊，");
          }
        });
    },
    // 邮件传送 ip 保存
    tanSend_table() {
      this.$disable_hint_test();
      let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
      // console.log(sid);

      // console.log(col, '5555')
      let str = this.$qs.stringify({
        __mode: "cfg_mynetwork",
        sid: sid,
        mtaip: this.mtaip,
        addordelip: 1,
        data_loadok: this.data_loadok1,
      });
      this.$axios
        .post(
          "/api/adm/cgi/newspam.cgi",
          str
          // screen: "real_filterlog.html",
        )
        .then((res) => {
          // console.log(res);
        this.$close_disable_hint_test();
          if (!res.data.fmstatus) {
            alert(res.data);
          } else if (res.data.fmstatus.code == "1") {
            alert(res.data.fmstatus.errmsg);
          } else if (res.data.fmstatus.code == "2") {
            alert(res.data.fmstatus.errmsg);
          } else if (res.data.fmstatus.code == "3") {
            // alert(res.data.fmstatus.errmsg);
            this.$router.push({
              name: "login",
            });
          } else {
            this.loading = true;

            this.getFileList1();
            this.$message({
              type: "success",
              message: `${this.$t("anti_gs1_tan.save_sueecss")}`,
            });
            this.mtaip = "";
            this.loading = false;
          }
        });
    },
    // 邮件传送 域名设置 保存
    tanSend_domain() {
      // this.loading = true;
      this.$disable_hint_test();
      let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
      // console.log(sid);

      // console.log(col, '5555')
      let str = this.$qs.stringify({
        __mode: "cfg_main_cf",
        sid: sid,
        mydomain: this.mydomain,
        myhostname: this.myhostname,
        data_loadok: this.data_loadok1,
      });
      this.$axios
        .post(
          "/api/adm/cgi/newspam.cgi",
          str
          // screen: "real_filterlog.html",
        )
        .then((res) => {
          // console.log(res);
          this.$close_disable_hint_test();
          if (!res.data.fmstatus) {
            alert(res.data);
          } else if (res.data.fmstatus.code == "1") {
            alert(res.data.fmstatus.errmsg);
          } else if (res.data.fmstatus.code == "2") {
            alert(res.data.fmstatus.errmsg);
          } else if (res.data.fmstatus.code == "3") {
            // alert(res.data.fmstatus.errmsg);
            this.$router.push({
              name: "login",
            });
          } else {
            this.loading = false;
            // this.getFileList1();
            this.$message({
              type: "success",
              message: `${this.$t("anti_gs1_tan.save_sueecss")}`,
            });
            this.mtaip = "";
          }
        });
    },
    // 邮件传送 ip 删除
    handleClick1(index, scope) {
      console.log(index, scope);
      this.$confirm(`${this.$t("anti_gs1_tan.del")}`, {
        confirmButtonText: `${this.$t("tan.confirm")}`,
        cancelButtonText: `${this.$t("tan.cancel")}`,
        type: "warning",
      })
        .then(() => {
          let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;

          let mtaip = scope.MYNETWORK;
          let str = this.$qs.stringify({
            __mode: "cfg_mynetwork",
            sid: sid,
            mtaip: mtaip,
            addordelip: 2,
            data_loadok: this.data_loadok1,
          });
          this.$axios.post("/api/adm/cgi/newspam.cgi", str).then((res) => {
            console.log(res);

            if (!res.data.fmstatus) {
              alert(res.data);
            } else if (res.data.fmstatus.code == "1") {
              alert(res.data.fmstatus.errmsg);
            } else if (res.data.fmstatus.code == "2") {
              alert(res.data.fmstatus.errmsg);
              //   this.getFileList();
            } else if (res.data.fmstatus.code == "3") {
              // alert(res.data.fmstatus.errmsg);
              this.$router.push({
                name: "login",
              });
            } else {
              // this.loading = false;
              this.getFileList1();
              this.$message({
                type: "success",
                message: `${this.$t("anti_gs1_tan.del1")}`,
              });
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: `${this.$t("anti_gs1_tan.del2")}`,
          });
        });
    },
  },
};
</script>

<style lang="less" scoped>
#iupfile {
  color: #0e2c5e;
}

// 表格居中位置
// 证书管理表头
.table10 {
  /deep/ .has-gutter th:nth-child(1) {
    text-align: center;
  }

  // /deep/ .has-gutter th:nth-child(2) {
  //     text-align: left;

  // }

  /deep/ .has-gutter th:nth-child(4) {
    text-align: center;
  }

  // 表格居中位置
  /deep/ .el-table__row td:nth-child(1) {
    text-align: center;
  }

  // /deep/ .el-table__row td:nth-child(2) {
  //     text-align: left;

  // }

  /deep/ .el-table__row td:nth-child(4) {
    text-align: center;
  }
}

// tls设置表头
.table06 {
  /deep/ .has-gutter th:nth-child(1) {
    text-align: center;
  }

  // /deep/ .has-gutter th:nth-child(2) {
  //     text-align: left;

  // }

  /deep/ .has-gutter th:nth-child(4) {
    text-align: center;
  }

  // 表格居中位置
  /deep/ .el-table__row td:nth-child(1) {
    text-align: center;
  }

  // /deep/ .el-table__row td:nth-child(2) {
  //     text-align: left;

  // }

  /deep/ .el-table__row td:nth-child(4) {
    text-align: center;
  }
}

// 路由设置表头
.table05 {
  /deep/ .has-gutter th:nth-child(1) {
    text-align: center;
  }

  /deep/ .has-gutter th:nth-child(2) {
    text-align: center;
  }

  /deep/ .has-gutter th:nth-child(3) {
    text-align: left;
  }

  /deep/ .has-gutter th:nth-child(4) {
    text-align: center;
  }

  /deep/ .has-gutter th:nth-child(5) {
    text-align: center;
  }

  // 表格居中位置
  /deep/ .el-table__row td:nth-child(1) {
    text-align: center;
  }

  /deep/ .el-table__row td:nth-child(3) {
    text-align: left;
  }

  /deep/ .el-table__row td:nth-child(2) {
    text-align: center;
  }

  /deep/ .el-table__row td:nth-child(4) {
    text-align: center;
  }

  /deep/ .el-table__row td:nth-child(5) {
    text-align: center;
  }
}

// 表格居中位置
// 表头
.table03 {
  /deep/ .has-gutter th:nth-child(1) {
    text-align: center;
  }

  /deep/ .has-gutter th:nth-child(2) {
    text-align: left;
  }

  /deep/ .has-gutter th:nth-child(3) {
    text-align: center;
  }

  // 表格居中位置
  /deep/ .el-table__row td:nth-child(1) {
    text-align: center;
  }

  /deep/ .el-table__row td:nth-child(2) {
    text-align: left;
  }

  /deep/ .el-table__row td:nth-child(3) {
    text-align: center;
  }
}

// 表格居中位置
// 表头
.table01 {
  /deep/ .has-gutter th:nth-child(1) {
    text-align: center;
  }

  /deep/ .has-gutter th:nth-child(2) {
    text-align: center;
  }

  /deep/ .has-gutter th:nth-child(3) {
    text-align: center;
  }

  // 表格居中位置
  /deep/ .el-table__row td:nth-child(1) {
    text-align: center;
  }

  /deep/ .el-table__row td:nth-child(2) {
    text-align: center;
  }

  /deep/ .el-table__row td:nth-child(3) {
    text-align: center;
  }
}

// 邮件传送
.base1_ip {
  display: flex;
  justify-content: space-around;
  // padding-bottom: 10px;

  .base1_left {
    width: 46%;

    .el-table {
      height: 517px;
    }

    p {
      margin: 0 14px;
      text-align: left;
      padding-left: 14px;
      font-size: 16px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #0e2c5e;
      background: #ffffff;
      border: 2px solid #d2d7e6;
      border-bottom: 0;
      line-height: 40px;
    }
  }

  .base1_right {
    width: 55%;
    // height: 100%;

    p {
      margin-right: 14px;
      text-align: left;
      padding-left: 14px;
      font-size: 16px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #0e2c5e;
      background: #ffffff;
      border: 2px solid #d2d7e6;
      border-bottom: 0;
      line-height: 40px;
    }

    ul {
      margin-right: 14px;
      background: #ffffff;

      border: 2px solid #d2d7e6;
      display: flex;
      flex-direction: column;
      align-items: center;

      li {
        padding-top: 30px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-size: 14px;
        color: #0e2c5e;
      }

      .el-input {
        width: 50%;
        padding: 12px 0;
      }

      .el-button {
        margin-bottom: 24px;
      }
    }

    .base1_right_c {
      margin-top: 14px;
      margin-right: 14px;
      // text-align: center;
      display: flex;
      flex-direction: column;
      align-items: center;
      border: 2px solid #d2d7e6;

      .base1_right_ctext {
        width: 100%;
        border: 0;
        padding: 0;

        border-bottom: 2px solid #d2d7e6;
        margin-right: 0;
      }

      ol {
        display: flex;
        align-items: center;
        justify-content: space-around;
        width: 75%;

        li:nth-child(1) {
          width: 140px;
          color: #0e2c5e;
          font-size: 14px;
          font-family: PingFangSC-Regular, PingFang SC;
          text-align: right;
        }

        li:nth-child(2) {
          flex: 1;
          color: #0e2c5e;
          font-size: 14px;
          font-family: PingFangSC-Regular, PingFang SC;
          // line-height: 34px;
          height: 40px;

          .el-input {
            width: 90%;
          }

          //  条件下 提示颜色
          /deep/ .el-alert {
            // padding: 6px 10px;
            margin-left: 10px;
            // line-height: 32px;
            height: 40px;
            line-height: 0;
            // height: 0;
            padding: 2px 10px;
            width: 91%;
            display: flex;
            align-items: flex-start;

            text-align: left;
          }

          .el-alert__content {
            padding: 2px 0;
          }

          /deep/.el-alert__icon {
            margin-top: 2px;
          }

          .el-alert--warning.is-light {
            background: rgba(253, 141, 67, 0.15);
          }

          /deep/ .el-alert__title {
            font-size: 12px !important;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #fd8d43;
          }
        }
      }
    }
  }
}

.base1_right_center {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 30px 0;
  background: #fff;

  .base1_right_center_button {
    display: flex;
    margin-left: 12px;
    // margin-top: 16px;

    .el-button {
      font-family: PingFangSC-Regular, PingFang SC;
      font-size: 14px;
      // line-height: 32px;
      height: 32px;
    }
  }
}

.count_city {
  width: 60px !important;

  /deep/ .el-input__inner {
    width: 60px !important;
  }
}

/deep/ .el-radio {
  margin-right: 10px;
}

// 隐藏滚动条
// .el-table ::-webkit-scrollbar {
//   width: 0px;
//   background: none;
// }

/deep/ .warning-row {
  background: #bdd7ee;
}

/deep/ .success-row {
  background: #ddebf7;
}

/deep/.el-tabs--border-card > .el-tabs__content {
  padding: 0;
}

/deep/ .el-input--suffix {
  width: 212px;
}

// 1

// /deep/ .el-select {
//   // padding-left: 30px;
//   width: 210px;
// }

.el-checkbox-group {
  display: flex;
}

.table span {
  font-size: 14px;
}

// 时间设置
.system_time {
  margin: 4px 0;
  padding-right: 10px;
  padding-left: 10px;
  height: 32px;
  line-height: 32px;

  background: rgba(169, 184, 214, 0.2);
  // border: 1px solid #D2D7E6;
  box-sizing: border-box;
}

.time {
  display: flex;
  flex-direction: column;
  border: 1px solid #dcdfe6;
  background: #f1f1f1;
  margin: 10px 0;
}

.time1 {
  display: flex;
  align-items: center;
  padding: 2px 0 2px 14px;
  font-size: 14px;
}

// 手动设置
.time-text1 {
  padding-left: 20px;
}

// 后台管理控制
.back {
  display: flex;
  font-size: 14px;
  line-height: 30px;
  align-items: center;
  padding: 6px 0;
}

// .back div {
//   margin: 0 10px;
// }
.back .el-input {
  margin: 0 10px;
}

.backText {
  text-align: right;
}

.backText1 {
  color: #999;
  font-size: 12px;
}

.back .el-input {
  width: 20%;
  padding: 0;
}

.time2 {
  display: flex;
  margin-left: 190px;
  margin-top: 10px;
}

.time2 .el-button {
  padding: 8px 24px;
  // margin: 10px ;
}

// License
/deep/ .el-textarea__inner {
  border: 1px solid #d2d7e6;
}

.License_style {
  font-family: PingFangSC-Medium, PingFang SC;
  font-size: 14px;
  font-weight: 500;
  color: #006be7;
  line-height: 34px;
}

.time3 {
  display: flex;
  align-items: center;
  // margin-left: 150px;
  font-size: 14px;
  padding: 4px 10px;
}

// selece
.selece1 {
  width: 130px;
}

// input 框
.back1 .input1 {
  width: 100px;
  margin: 0 10px;
}

// 单选框
.check1 {
  margin: 0 10px;
}

.backText2 {
  margin-left: 40px;
}

.backText3 {
  margin-left: 30px;
}

.back1 .input5-1 {
  width: 100px;
}

// /deep/ .el-tabs--top .el-tabs__item.is-top:nth-child(2) {
//     padding-left: 20px;
//     border-left: 0px;
// }

// /deep/ .el-tabs--top .el-tabs__item.is-top:last-child {
//     padding-right: 20px;
// }

// 弹框下的复选框
.el-checkbox:last-of-type {
  margin-right: 10px;
}

@import "../../css/table.less";
@import "../../css/lie_td.less";
@import "../../css/pou_up.less";
@import "../../css/fengye.less";
@import "../../css/drag.less";

/deep/ .system_time_lacal {
  padding: 0px;
  height: 30px;
  line-height: 30px;
  box-sizing: border-box;
  margin-top: 7px;
  margin-left: 10px;
  background: #006be7;
  font-family: PingFangSC-Regular, PingFang SC;
  color: #ffffff;
  border: none;
  padding: 0 16px !important;
}

.selft_build1_length {
  padding: 4px 0 !important;

  /deep/.el-alert__content {
    line-height: 0;
  }

  // /deep/ .el-alert__title {
  // }
}
.base7_a2_time{
 /deep/ .el-input__inner{
    padding-left:34px
  }
}
.pop-up .pop_up_text_ROUTE_ADDRESS,.pop-up .pop_up_text_ROUTE_ADDRESS_edit {
  width: 100%;
}
.pop_up_text_ROUTE_ADDRESS,.pop_up_text_ROUTE_ADDRESS_edit {
  background: #eee;
}
</style>
